import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './Admin.css';

import API_URL from '../../config';


/* ═══════════════════════════════════════════════
   SVG Icons
   ═══════════════════════════════════════════════ */
const Icon = ({ d, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d={d} /></svg>
);
const Icons = {
  dashboard: <><rect x="3" y="3" width="7" height="7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><rect x="14" y="3" width="7" height="7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><rect x="14" y="14" width="7" height="7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><rect x="3" y="14" width="7" height="7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></>,
  users: <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></>,
  plans: <><rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" /></>,
  disciplines: <><polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" /></>,
  projects: <><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" /></>,
  roles: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></>,
  forum: <><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></>,
  posts: <><path d="M4 11a9 9 0 0 1 9 9" /><path d="M4 4a16 16 0 0 1 16 16" /><circle cx="5" cy="19" r="1" /></>,
  jobs: <><rect x="2" y="7" width="20" height="14" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></>,
  contacts: <><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></>,
  trash: <><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></>,
  edit: <><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></>,
  check: <><polyline points="20 6 9 17 4 12" /></>,
  ban: <><circle cx="12" cy="12" r="10" /><line x1="4.93" y1="4.93" x2="19.07" y2="19.07" /></>,
  back: <><path d="M19 12H5" /><polyline points="12 19 5 12 12 5" /></>,
  plus: <><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></>,
  x: <><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></>,
};

const SvgIcon = ({ name, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{Icons[name]}</svg>
);

/* ═══════════════════════════════════════════════
   Section config
   ═══════════════════════════════════════════════ */
const sectionList = [
  { id: 'dashboard', label: 'Genel Bakış', icon: 'dashboard' },
  { id: 'users', label: 'Kullanıcılar', icon: 'users' },
  { id: 'plans', label: 'Planlar & Abonelik', icon: 'plans' },
  { id: 'disciplines', label: 'Disiplin Yönetimi', icon: 'disciplines' },
  { id: 'projects', label: 'Projeler', icon: 'projects' },
  { id: 'system-roles', label: 'Sistem Rolleri', icon: 'roles' },
  { id: 'forum', label: 'Forum', icon: 'forum' },
  { id: 'posts', label: 'Paylaşımlar', icon: 'posts' },
  { id: 'jobs', label: 'İş İlanları', icon: 'jobs' },
  { id: 'contacts', label: 'İletişim', icon: 'contacts' },
  { id: 'testimonials', label: 'Yorumlar', icon: 'forum' },
  { id: 'legal', label: 'Yasal Metinler', icon: 'roles' },
  { id: 'pricing', label: 'Fiyatlandırma', icon: 'plans' },
  { id: 'navigation', label: 'Menü & Anasayfa', icon: 'settings' },
  { id: 'distribution-companies', label: 'Dağıtım Şirketleri', icon: 'disciplines' },
  { id: 'settings', label: 'Sistem Ayarları', icon: 'settings' },
];

const EDITOR_ACCESS_LEVELS = [
  { value: 'full', label: 'Tam Erişim' },
  { value: 'advanced', label: 'Gelişmiş' },
  { value: 'standard', label: 'Standart' },
  { value: 'basic', label: 'Temel' },
  { value: 'annotate', label: 'Not / İşaretleme' },
  { value: 'view', label: 'Sadece Görüntüleme' },
];

// Paydaş kategorileri — sektör rolleriyle aynı anahtarlar kullanılır.
// Böylece (disiplin + sektör rolü) → party_type otomatik eşleşebilir.
const PARTY_CATEGORIES = [
  { value: 'muellif',    label: 'Müellif' },
  { value: 'kontrolor',  label: 'Kontrolör' },
  { value: 'yuklenici',  label: 'Yüklenici' },
  { value: 'is_sahibi',  label: 'İş Sahibi' },
  { value: 'ogrenci',    label: 'Öğrenci' },
  // Eski/legacy kategoriler (geriye dönük uyumluluk)
  { value: 'producer',   label: 'Üretici (eski)' },
  { value: 'client',     label: 'Müşteri (eski)' },
  { value: 'authority',  label: 'Otorite (eski)' },
];

const PARTY_CATEGORY_COLOR = {
  muellif:   'purple',
  kontrolor: 'blue',
  yuklenici: 'orange',
  is_sahibi: 'green',
  ogrenci:   'gray',
  producer:  'purple',
  client:    'green',
  authority: 'blue',
};

const TOOL_ACCESS_LEVELS = ['full', 'advanced', 'standard', 'basic', 'annotate', 'view'];

const TOOL_CATEGORIES = {
  drawing: 'Çizim Araçları',
  electrical: 'Elektrik Tesisat',
  panels: 'Paneller & Editörler',
  utility: 'Yardımcı Araçlar',
  export: 'Dışa Aktarma',
  project: 'Proje Yönetimi'
};
const TOOL_CAT_ORDER = ['drawing', 'electrical', 'panels', 'utility', 'export', 'project'];

/* ═══════════════════════════════════════════════
   MAIN COMPONENT
   ═══════════════════════════════════════════════ */
const Admin = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [section, setSection] = useState('dashboard');
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  // Data states
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [plans, setPlans] = useState([]);
  const [disciplines, setDisciplines] = useState([]);
  const [sheetTypes, setSheetTypes] = useState([]);
  const [partyTypes, setPartyTypes] = useState([]);
  const [partyCategories, setPartyCategories] = useState([]);
  const [editorTools, setEditorTools] = useState([]);
  const [drawingEditors, setDrawingEditors] = useState([]);
  const [systemRoles, setSystemRoles] = useState([]);
  const [permTemplate, setPermTemplate] = useState({});
  const [projects, setProjects] = useState([]);
  const [threads, setThreads] = useState([]);
  const [posts, setPosts] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [legalAcceptances, setLegalAcceptances] = useState([]);
  const [legalSubTab, setLegalSubTab] = useState('texts');
  // Navigasyon konfigürasyonu (Menü & Anasayfa)
  const [navConfig, setNavConfig] = useState({
    homeShortcuts: [],
    topbarMenus: { haberler: [], sorular: [], daha_fazlasi: [] },
  });
  const [navSaving, setNavSaving] = useState(false);
  const [navSavedAt, setNavSavedAt] = useState(null);

  // Audit log state (Erişim Logları sekmesi)
  const [auditLogs, setAuditLogs] = useState([]);
  const [auditTotal, setAuditTotal] = useState(0);
  const [auditSummary, setAuditSummary] = useState(null);
  const [auditIntegrity, setAuditIntegrity] = useState(null);
  const [auditFilter, setAuditFilter] = useState({ category: '', q: '', from: '', to: '' });
  const [auditLoading, setAuditLoading] = useState(false);
  const [sysSettings, setSysSettings] = useState({});

  // Dağıtım şirketleri yönetimi
  const [distCompanies, setDistCompanies] = useState([]);
  const [distForm, setDistForm] = useState({ name: '', fullName: '', website: '', iller: '', not: '' });
  const [distEditing, setDistEditing] = useState(null); // id | null (null = yeni ekleme)

  // Pricing states
  const [pricingEditors, setPricingEditors] = useState([]);
  const [membershipTiers, setMembershipTiers] = useState([]);
  const [durationDiscounts, setDurationDiscounts] = useState([]);
  const [pricingTab, setPricingTab] = useState('tiers');
  const [pricingStatusFilter, setPricingStatusFilter] = useState('all');
  const [pricingVoltageFilter, setPricingVoltageFilter] = useState('all');
  // Simulator state
  const [simTierId, setSimTierId] = useState(null);
  const [simEditorIds, setSimEditorIds] = useState([]);
  const [simDuration, setSimDuration] = useState(1);
  const [simResult, setSimResult] = useState(null);
  // Simulator local price overrides: { [id]: price }
  const [simTierPrices, setSimTierPrices] = useState({});
  const [simTierDiscounts, setSimTierDiscounts] = useState({});
  const [simEditorPrices, setSimEditorPrices] = useState({});
  const [simDirty, setSimDirty] = useState(false);

  // Modal states
  const [modal, setModal] = useState(null); // { type, data }

  // Discipline sub-tab
  const [discTab, setDiscTab] = useState('overview');
  const [selectedDiscipline, setSelectedDiscipline] = useState(null);
  const [toolMatrixDirty, setToolMatrixDirty] = useState(false);
  const [matrixEditorId, setMatrixEditorId] = useState(null);
  const [matrixPlanId, setMatrixPlanId] = useState(null);
  const [matrixPartyId, setMatrixPartyId] = useState(null);

  // Drawing Editor tool matrix (Çizim Editörleri tab)
  const [deSelectedEditorId, setDeSelectedEditorId] = useState(null);
  const [deMatrixDirty, setDeMatrixDirty] = useState(false);

  /* ─── API Helper ─── */
  const apiFetch = useCallback(async (path, opts = {}) => {
    try {
      const tk = localStorage.getItem('projabze_token');
      const res = await fetch(`${API_URL}/api/admin${path}`, {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tk}` },
        ...opts
      });
      if (res.status === 403) { navigate('/dashboard'); return null; }
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        return { _error: true, message: err.message || 'Hata oluştu' };
      }
      return res.json();
    } catch (err) {
      console.error('Admin API error:', err);
      return null;
    }
  }, [navigate]);

  /* ─── Dağıtım Şirketleri API ─── */
  const fetchDistCompanies = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/distribution-companies`);
      if (res.ok) {
        const data = await res.json();
        setDistCompanies(data.companies || []);
      }
    } catch (err) {
      console.error('Dağıtım şirketleri alınamadı:', err);
    }
  }, []);

  const distApiFetch = useCallback(async (path, opts = {}) => {
    const tk = localStorage.getItem('projabze_token');
    const res = await fetch(`${API_URL}/api/distribution-companies${path}`, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tk}` },
      ...opts,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      alert(err.message || 'Hata oluştu.');
      return null;
    }
    return res.json();
  }, []);

  /* ─── Auth Check ─── */
  useEffect(() => {
    const stored = localStorage.getItem('projabze_user');
    if (!stored) { navigate('/'); return; }
    const u = JSON.parse(stored);
    if (u.role !== 'admin') { navigate('/dashboard'); return; }
    setUser(u);
  }, [navigate]);

  /* ─── Load Section Data ─── */
  const loadSection = useCallback(async (sec) => {
    setLoading(true);
    setSearchTerm('');
    switch (sec) {
      case 'dashboard': {
        const d = await apiFetch('/stats');
        if (d && !d._error) setStats(d);
        break;
      }
      case 'users': {
        const d = await apiFetch('/users');
        if (d && !d._error) setUsers(d.users);
        // Also load plans and party types for dropdowns
        const p = await apiFetch('/plans');
        if (p && !p._error) setPlans(p.plans);
        const pt = await apiFetch('/party-types');
        if (pt && !pt._error) setPartyTypes(pt.partyTypes);
        break;
      }
      case 'plans': {
        const d = await apiFetch('/plans');
        if (d && !d._error) setPlans(d.plans);
        break;
      }
      case 'disciplines': {
        const d = await apiFetch('/disciplines');
        if (d && !d._error) {
          setDisciplines(d.disciplines);
          if (d.disciplines.length > 0 && !selectedDiscipline) {
            setSelectedDiscipline(d.disciplines[0]);
          }
        }
        // Load sub-data
        const st = await apiFetch('/sheet-types');
        if (st && !st._error) setSheetTypes(st.sheetTypes);
        const pt = await apiFetch('/party-types');
        if (pt && !pt._error) setPartyTypes(pt.partyTypes);
        const pc = await apiFetch('/party-categories');
        if (pc && !pc._error) setPartyCategories(pc.items);
        const et = await apiFetch('/editor-tools');
        if (et && !et._error) setEditorTools(et.editorTools);
        const de = await apiFetch('/drawing-editors');
        if (de && !de._error) setDrawingEditors(de.drawingEditors);
        const pl = await apiFetch('/plans');
        if (pl && !pl._error) setPlans(pl.plans);
        break;
      }
      case 'projects': {
        const d = await apiFetch('/projects');
        if (d && !d._error) setProjects(d.projects);
        break;
      }
      case 'system-roles': {
        const d = await apiFetch('/system-roles');
        if (d && !d._error) { setSystemRoles(d.systemRoles); setPermTemplate(d.permissionTemplate); }
        break;
      }
      case 'forum': {
        const d = await apiFetch('/forum');
        if (d && !d._error) setThreads(d.threads);
        break;
      }
      case 'posts': {
        const d = await apiFetch('/posts');
        if (d && !d._error) setPosts(d.posts);
        break;
      }
      case 'jobs': {
        const d = await apiFetch('/jobs');
        if (d && !d._error) setJobs(d.listings);
        break;
      }
      case 'contacts': {
        const d = await apiFetch('/contacts');
        if (d && !d._error) setContacts(d.contacts);
        break;
      }
      case 'testimonials': {
        // Testimonials route uses /api/testimonials (not /api/admin)
        try {
          const tk = localStorage.getItem('projabze_token');
          const r = await fetch(`${API_URL}/api/testimonials/admin`, {
            headers: { Authorization: `Bearer ${tk}` },
          });
          if (r.ok) {
            const d = await r.json();
            setTestimonials(d.testimonials || []);
          }
        } catch (e) { /* ignore */ }
        break;
      }
      case 'legal': {
        const d = await apiFetch('/legal-acceptances');
        if (d && !d._error) setLegalAcceptances(d.acceptances || []);
        const s = await apiFetch('/audit-logs/summary');
        if (s && !s._error) setAuditSummary(s);
        break;
      }
      case 'settings': {
        const d = await apiFetch('/settings');
        if (d && !d._error) setSysSettings(d.settings);
        const p = await apiFetch('/plans');
        if (p && !p._error) setPlans(p.plans);
        break;
      }
      case 'pricing': {
        const t = await apiFetch('/membership-tiers');
        if (t && !t._error) setMembershipTiers(t.tiers);
        const e = await apiFetch('/pricing-editors');
        if (e && !e._error) setPricingEditors(e.editors);
        const dd = await apiFetch('/duration-discounts');
        if (dd && !dd._error) setDurationDiscounts(dd.discounts);
        break;
      }
      case 'navigation': {
        try {
          const r = await fetch(`${API_URL}/api/system-settings/navigation`);
          if (r.ok) {
            const d = await r.json();
            if (d.navigation) setNavConfig(d.navigation);
          }
        } catch (_) {}
        break;
      }
      case 'distribution-companies': {
        await fetchDistCompanies();
        break;
      }
      default: break;
    }
    setLoading(false);
  }, [apiFetch, selectedDiscipline, fetchDistCompanies]);

  useEffect(() => {
    if (user) loadSection(section);
  }, [section, user, loadSection]);

  // Auto-calculate simulator locally on every parameter change
  useEffect(() => {
    if (!simTierId) { setSimResult(null); return; }
    const tier = membershipTiers.find(t => t.id === simTierId);
    if (!tier) { setSimResult(null); return; }
    const dur = durationDiscounts.find(d => d.months === simDuration) || { extraDiscountPct: 0, months: 1 };
    const tierPrice = simTierPrices[tier.id] !== undefined ? simTierPrices[tier.id] : tier.monthlyPrice;
    const tierDisc = simTierDiscounts[tier.id] !== undefined ? simTierDiscounts[tier.id] : tier.editorDiscountPct;
    const maxDisc = 0.40;
    const effectiveDiscount = Math.min(tierDisc + dur.extraDiscountPct, maxDisc);

    const editors = simEditorIds.map(eid => {
      const ed = pricingEditors.find(e => e.id === eid);
      if (!ed || ed.status !== 'published') return null;
      const lp = simEditorPrices[eid] !== undefined ? simEditorPrices[eid] : ed.listPrice;
      const isIncluded = (tier.includedEditorIds || []).includes(eid);
      const finalPrice = isIncluded ? 0 : Math.round(lp * (1 - effectiveDiscount));
      return { id: ed.id, name: ed.name, voltageLevel: ed.voltageLevel, listPrice: lp, finalPrice, isIncluded };
    }).filter(Boolean);

    const totalList = editors.reduce((s, e) => s + e.listPrice, 0);
    const totalFinal = editors.reduce((s, e) => s + e.finalPrice, 0);
    const monthlyEq = tierPrice + totalFinal;
    const totalWithMem = totalList + tierPrice;
    const savingPct = totalWithMem > 0 ? Math.round((1 - monthlyEq / totalWithMem) * 100) : 0;

    setSimResult({
      membershipMonthly: tierPrice, tierName: tier.name,
      editorDiscount: tierDisc, durationDiscount: dur.extraDiscountPct, effectiveDiscount,
      editors, totalList, totalFinal, monthlyEquivalent: monthlyEq, savingPct,
      durationMonths: dur.months, totalPayment: monthlyEq * dur.months
    });
  }, [simTierId, simEditorIds, simDuration, membershipTiers, pricingEditors, durationDiscounts, simTierPrices, simTierDiscounts, simEditorPrices]);

  /* ─── Helpers ─── */
  const formatDate = (d) => d ? new Date(d).toLocaleDateString('tr-TR') : '—';
  const formatMoney = (v) => v === 0 ? 'Ücretsiz' : `₺${v}`;

  const handleDelete = async (endpoint, id, setter) => {
    if (!window.confirm('Silmek istediğinize emin misiniz?')) return;
    await apiFetch(`/${endpoint}/${id}`, { method: 'DELETE' });
    setter(prev => prev.filter(i => i.id !== id));
  };

  if (!user) return null;

  /* ═══════════════════════════════════════════════
     RENDER — Dashboard
     ═══════════════════════════════════════════════ */
  const renderDashboard = () => {
    if (!stats) return <div className="adm-loading">Yükleniyor...</div>;
    const cards = [
      { label: 'Toplam Kullanıcı', value: stats.users.total, sub: `+${stats.users.newThisWeek} bu hafta`, color: 'purple' },
      { label: 'Projeler', value: stats.projects.total, sub: `${stats.projects.shares} paylaşım`, color: 'blue' },
      { label: 'Disiplinler', value: stats.platform.disciplines, sub: `${stats.platform.sheetTypes} pafta tipi`, color: 'green' },
      { label: 'Forum', value: stats.forum.threads, sub: `${stats.forum.replies} yanıt`, color: 'orange' },
      { label: 'İş İlanları', value: stats.jobs.listings, sub: `${stats.jobs.applications} başvuru`, color: 'rose' },
      { label: 'İletişim', value: stats.contacts.total, sub: 'Mesaj', color: 'yellow' },
    ];
    return (
      <>
        <div className="adm-stats-grid">
          {cards.map(c => (
            <div className={`adm-stat-card ${c.color}`} key={c.label}>
              <div className="adm-stat-value">{c.value}</div>
              <div className="adm-stat-label">{c.label}</div>
              <div className="adm-stat-sub">{c.sub}</div>
            </div>
          ))}
        </div>
        <div className="adm-detail-grid">
          <div className="adm-detail-card">
            <h3>Kullanıcı Dağılımı</h3>
            <div className="adm-detail-rows">
              <div className="adm-detail-row"><span>Admin</span><span className="adm-badge purple">{stats.users.admins}</span></div>
              <div className="adm-detail-row"><span>Kullanıcı</span><span className="adm-badge blue">{stats.users.regularUsers}</span></div>
            </div>
          </div>
          <div className="adm-detail-card">
            <h3>Plan Dağılımı</h3>
            <div className="adm-detail-rows">
              {Object.entries(stats.plans).map(([code, count]) => (
                <div className="adm-detail-row" key={code}><span>{code}</span><span className="adm-badge">{count}</span></div>
              ))}
            </div>
          </div>
          <div className="adm-detail-card">
            <h3>Platform</h3>
            <div className="adm-detail-rows">
              <div className="adm-detail-row"><span>Paydaş Tipleri</span><span className="adm-badge green">{stats.platform.partyTypes}</span></div>
              <div className="adm-detail-row"><span>Aktif Planlar</span><span className="adm-badge blue">{stats.platform.activePlans}</span></div>
              <div className="adm-detail-row"><span>Bugün Yeni</span><span className="adm-badge orange">+{stats.users.newToday}</span></div>
            </div>
          </div>
        </div>
      </>
    );
  };

  /* ═══════════════════════════════════════════════
     RENDER — Users
     ═══════════════════════════════════════════════ */
  const renderUsers = () => {
    const filtered = users.filter(u =>
      `${u.firstName} ${u.lastName} ${u.email}`.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return (
      <>
        <div className="adm-toolbar">
          <input className="adm-search" placeholder="Kullanıcı ara..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
          <button className="adm-btn primary" onClick={() => setModal({
            type: 'create-user',
            data: { firstName: '', lastName: '', email: '', password: '', role: 'user', planId: 'plan-free', partyTypeId: '' }
          })}>+ Yeni Kullanıcı</button>
        </div>
        <div className="adm-table-wrap">
          <table className="adm-table">
            <thead>
              <tr><th>Kullanıcı</th><th>E-posta</th><th>Rol</th><th>Plan</th><th>Paydaş Tipi</th><th>Durum</th><th>Kayıt</th><th>İşlem</th></tr>
            </thead>
            <tbody>
              {filtered.map(u => (
                <tr key={u.id}>
                  <td><div className="adm-user-cell"><div className="adm-user-avatar">{(u.firstName?.[0] || '') + (u.lastName?.[0] || '')}</div><span>{u.firstName} {u.lastName}</span></div></td>
                  <td>{u.email}</td>
                  <td>
                    <select className="adm-select-sm" value={u.role} disabled={u.id === user?.id} title={u.id === user?.id ? 'Kendi rolünüzü değiştiremezsiniz' : ''} onChange={async e => {
                      const newRole = e.target.value;
                      const res = await apiFetch(`/users/${u.id}`, { method: 'PUT', body: JSON.stringify({ role: newRole }) });
                      if (res && !res._error) {
                        setUsers(prev => prev.map(x => x.id === u.id ? { ...x, role: newRole } : x));
                      } else {
                        alert(res?.message || 'Rol değiştirilemedi.');
                      }
                    }}>
                      <option value="user">Kullanıcı</option>
                      <option value="moderator">Moderatör</option>
                      <option value="admin">Admin</option>
                    </select>
                  </td>
                  <td>
                    <select className="adm-select-sm" value={u.planId || ''} onChange={async e => {
                      const newPlanId = e.target.value;
                      const res = await apiFetch(`/users/${u.id}`, { method: 'PUT', body: JSON.stringify({ planId: newPlanId }) });
                      if (res && !res._error) {
                        const plan = plans.find(p => p.id === newPlanId);
                        setUsers(prev => prev.map(x => x.id === u.id ? { ...x, planId: newPlanId, planName: plan?.name } : x));
                      } else {
                        alert(res?.message || 'Plan değiştirilemedi.');
                      }
                    }}>
                      {plans.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                    </select>
                  </td>
                  <td><span className="adm-badge">{u.partyTypeName || '—'}</span></td>
                  <td>
                    <span className={`adm-status-dot ${u.status === 'banned' ? 'banned' : 'active'}`}>
                      {u.status === 'banned' ? 'Engelli' : 'Aktif'}
                    </span>
                  </td>
                  <td>{formatDate(u.createdAt)}</td>
                  <td>
                    <div className="adm-actions">
                      {u.status !== 'banned' ? (
                        <button className="adm-btn-sm warn" onClick={async () => {
                          await apiFetch(`/users/${u.id}`, { method: 'PUT', body: JSON.stringify({ status: 'banned' }) });
                          setUsers(prev => prev.map(x => x.id === u.id ? { ...x, status: 'banned' } : x));
                        }} title="Engelle"><SvgIcon name="ban" size={14} /></button>
                      ) : (
                        <button className="adm-btn-sm ok" onClick={async () => {
                          await apiFetch(`/users/${u.id}`, { method: 'PUT', body: JSON.stringify({ status: 'active' }) });
                          setUsers(prev => prev.map(x => x.id === u.id ? { ...x, status: 'active' } : x));
                        }} title="Aktif Et"><SvgIcon name="check" size={14} /></button>
                      )}
                      <button className="adm-btn-sm danger" onClick={() => handleDelete('users', u.id, setUsers)} title="Sil"><SvgIcon name="trash" size={14} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {filtered.length === 0 && <div className="adm-empty">Kullanıcı bulunamadı.</div>}
        </div>

        {modal?.type === 'create-user' && (
          <div className="adm-modal-backdrop" onClick={() => setModal(null)}>
            <div className="adm-modal" onClick={e => e.stopPropagation()}>
              <h3>Yeni Kullanıcı Oluştur</h3>
              <div className="adm-modal-form">
                <div className="adm-form-row">
                  <input placeholder="Ad" value={modal.data.firstName} onChange={e => setModal(m => ({ ...m, data: { ...m.data, firstName: e.target.value } }))} />
                  <input placeholder="Soyad" value={modal.data.lastName} onChange={e => setModal(m => ({ ...m, data: { ...m.data, lastName: e.target.value } }))} />
                </div>
                <input placeholder="E-posta" type="email" value={modal.data.email} onChange={e => setModal(m => ({ ...m, data: { ...m.data, email: e.target.value } }))} />
                <input placeholder="Şifre" type="password" value={modal.data.password} onChange={e => setModal(m => ({ ...m, data: { ...m.data, password: e.target.value } }))} />
                <div className="adm-form-row">
                  <select value={modal.data.role} onChange={e => setModal(m => ({ ...m, data: { ...m.data, role: e.target.value } }))}>
                    <option value="user">Kullanıcı</option>
                    <option value="moderator">Moderatör</option>
                    <option value="admin">Admin</option>
                  </select>
                  <select value={modal.data.planId} onChange={e => setModal(m => ({ ...m, data: { ...m.data, planId: e.target.value } }))}>
                    {plans.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                  </select>
                </div>
              </div>
              <div className="adm-modal-actions">
                <button className="adm-btn" onClick={() => setModal(null)}>İptal</button>
                <button className="adm-btn primary" onClick={async () => {
                  const d = modal.data;
                  if (!d.firstName || !d.lastName || !d.email || !d.password) return;
                  const res = await apiFetch('/users', { method: 'POST', body: JSON.stringify(d) });
                  if (res && !res._error) {
                    setUsers(prev => [...prev, { ...res.user, status: 'active', createdAt: new Date().toISOString(), planName: plans.find(p => p.id === d.planId)?.name, partyTypeName: '—' }]);
                    setModal(null);
                  }
                }}>Oluştur</button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  /* ═══════════════════════════════════════════════
     RENDER — Plans
     ═══════════════════════════════════════════════ */
  const renderPlans = () => (
    <>
      <div className="adm-toolbar">
        <span className="adm-toolbar-info">{plans.length} plan tanımlı</span>
        <button className="adm-btn primary" onClick={() => setModal({
          type: 'plan',
          editing: false,
          data: { code: '', name: '', tier: plans.length, toolAccess: 'basic', price: { monthly: 0, yearly: 0 }, limits: { maxProjects: 1, maxSheetsPerProject: 1, maxCollaborators: 1, storageGB: 1, exportFormats: ['pdf'], maxDisciplines: 1 } }
        })}>+ Yeni Plan</button>
      </div>
      <div className="adm-plans-grid">
        {plans.map(p => (
          <div className={`adm-plan-card ${p.tier === 0 ? 'free' : p.tier === 1 ? 'starter' : p.tier === 2 ? 'pro' : 'business'}`} key={p.id}>
            <div className="adm-plan-header">
              <h3>{p.name}</h3>
              {p.isSystem && <span className="adm-badge purple">Sistem</span>}
            </div>
            <div className="adm-plan-price">
              <span className="adm-plan-amount">{formatMoney(p.price?.monthly || 0)}</span>
              {p.price?.monthly > 0 && <span className="adm-plan-period">/ay</span>}
            </div>
            <div className="adm-plan-limits">
              <div className="adm-plan-limit"><span>Proje</span><span>{p.limits?.maxProjects === -1 ? '∞' : p.limits?.maxProjects}</span></div>
              <div className="adm-plan-limit"><span>Pafta/Proje</span><span>{p.limits?.maxSheetsPerProject === -1 ? '∞' : p.limits?.maxSheetsPerProject}</span></div>
              <div className="adm-plan-limit"><span>İşbirlikçi</span><span>{p.limits?.maxCollaborators === -1 ? '∞' : p.limits?.maxCollaborators}</span></div>
              <div className="adm-plan-limit"><span>Depolama</span><span>{p.limits?.storageGB} GB</span></div>
              <div className="adm-plan-limit"><span>Araç Erişimi</span><span className="adm-badge green">{p.toolAccess}</span></div>
              <div className="adm-plan-limit"><span>Export</span><span>{(p.limits?.exportFormats || []).join(', ')}</span></div>
            </div>
            <div className="adm-plan-footer">
              <span className="adm-plan-users"><SvgIcon name="users" size={14} /> {p.userCount || 0} kullanıcı</span>
              <div className="adm-actions">
                <button className="adm-btn-sm" onClick={() => setModal({ type: 'plan', editing: true, data: { ...p } })} title="Düzenle"><SvgIcon name="edit" size={14} /></button>
                {!p.isSystem && <button className="adm-btn-sm danger" onClick={() => handleDelete('plans', p.id, setPlans)} title="Sil"><SvgIcon name="trash" size={14} /></button>}
              </div>
            </div>
          </div>
        ))}
      </div>

      {modal?.type === 'plan' && (
        <div className="adm-modal-backdrop" onClick={() => setModal(null)}>
          <div className="adm-modal adm-modal-lg" onClick={e => e.stopPropagation()}>
            <h3>{modal.editing ? 'Plan Düzenle' : 'Yeni Plan'}</h3>
            <div className="adm-modal-form">
              <div className="adm-form-row">
                <input placeholder="Plan Kodu (ör: enterprise)" value={modal.data.code} onChange={e => setModal(m => ({ ...m, data: { ...m.data, code: e.target.value } }))} disabled={modal.editing} />
                <input placeholder="Plan Adı" value={modal.data.name} onChange={e => setModal(m => ({ ...m, data: { ...m.data, name: e.target.value } }))} />
              </div>
              <div className="adm-form-row">
                <label className="adm-form-label">Kademe (Tier)
                  <input type="number" value={modal.data.tier} onChange={e => setModal(m => ({ ...m, data: { ...m.data, tier: Number(e.target.value) } }))} />
                </label>
                <label className="adm-form-label">Araç Erişimi
                  <select value={modal.data.toolAccess} onChange={e => setModal(m => ({ ...m, data: { ...m.data, toolAccess: e.target.value } }))}>
                    <option value="basic">Basic</option>
                    <option value="standard">Standard</option>
                    <option value="advanced">Advanced</option>
                    <option value="full">Full</option>
                  </select>
                </label>
              </div>
              <div className="adm-form-row">
                <label className="adm-form-label">Aylık Fiyat (₺)
                  <input type="number" value={modal.data.price?.monthly || 0} onChange={e => setModal(m => ({ ...m, data: { ...m.data, price: { ...m.data.price, monthly: Number(e.target.value) } } }))} />
                </label>
                <label className="adm-form-label">Yıllık Fiyat (₺)
                  <input type="number" value={modal.data.price?.yearly || 0} onChange={e => setModal(m => ({ ...m, data: { ...m.data, price: { ...m.data.price, yearly: Number(e.target.value) } } }))} />
                </label>
              </div>
              <h4 className="adm-form-subtitle">Limitler</h4>
              <div className="adm-form-row">
                <label className="adm-form-label">Maks. Proje (-1=∞)
                  <input type="number" value={modal.data.limits?.maxProjects} onChange={e => setModal(m => ({ ...m, data: { ...m.data, limits: { ...m.data.limits, maxProjects: Number(e.target.value) } } }))} />
                </label>
                <label className="adm-form-label">Maks. Pafta/Proje (-1=∞)
                  <input type="number" value={modal.data.limits?.maxSheetsPerProject} onChange={e => setModal(m => ({ ...m, data: { ...m.data, limits: { ...m.data.limits, maxSheetsPerProject: Number(e.target.value) } } }))} />
                </label>
              </div>
              <div className="adm-form-row">
                <label className="adm-form-label">Maks. İşbirlikçi (-1=∞)
                  <input type="number" value={modal.data.limits?.maxCollaborators} onChange={e => setModal(m => ({ ...m, data: { ...m.data, limits: { ...m.data.limits, maxCollaborators: Number(e.target.value) } } }))} />
                </label>
                <label className="adm-form-label">Depolama (GB)
                  <input type="number" value={modal.data.limits?.storageGB} onChange={e => setModal(m => ({ ...m, data: { ...m.data, limits: { ...m.data.limits, storageGB: Number(e.target.value) } } }))} />
                </label>
              </div>
            </div>
            <div className="adm-modal-actions">
              <button className="adm-btn" onClick={() => setModal(null)}>İptal</button>
              <button className="adm-btn primary" onClick={async () => {
                const d = modal.data;
                if (!d.code || !d.name) return;
                if (modal.editing) {
                  const res = await apiFetch(`/plans/${d.id}`, { method: 'PUT', body: JSON.stringify(d) });
                  if (res && !res._error) setPlans(prev => prev.map(p => p.id === d.id ? { ...p, ...d } : p));
                } else {
                  const res = await apiFetch('/plans', { method: 'POST', body: JSON.stringify(d) });
                  if (res && !res._error) setPlans(prev => [...prev, { ...res.plan, userCount: 0 }]);
                }
                setModal(null);
              }}>{modal.editing ? 'Güncelle' : 'Oluştur'}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );

  /* ═══════════════════════════════════════════════
     RENDER — Disciplines
     ═══════════════════════════════════════════════ */
  const filteredSheetTypes = sheetTypes.filter(s => selectedDiscipline && s.disciplineId === selectedDiscipline.id);
  const filteredPartyTypes = partyTypes.filter(p => selectedDiscipline && p.disciplineId === selectedDiscipline.id);
  const filteredEditorTools = editorTools.filter(t => selectedDiscipline && (t.disciplineId === selectedDiscipline.id || t.disciplineId === null));
  const filteredDrawingEditors = drawingEditors.filter(de => selectedDiscipline && de.disciplineId === selectedDiscipline.id);

  // When a drawing editor is selected in the matrix, filter sheets to only those the editor supports
  const selectedDrawingEditor = matrixEditorId ? drawingEditors.find(de => de.id === matrixEditorId) : null;
  const matrixSheetTypes = selectedDrawingEditor
    ? filteredSheetTypes.filter(s => (selectedDrawingEditor.sheetAccess || []).includes(s.code))
    : filteredSheetTypes;

  // Drawing Editor tool matrix (Çizim Editörleri tab)
  const deSelectedEditor = deSelectedEditorId ? drawingEditors.find(de => de.id === deSelectedEditorId) : null;
  const deMatrixSheets = deSelectedEditor
    ? filteredSheetTypes.filter(s => (deSelectedEditor.sheetAccess || []).includes(s.code))
    : [];

  const getDeToolAcc = (tool) => {
    if (!deSelectedEditor) return [];
    return deSelectedEditor.toolSheetAccess?.[tool.id] || [];
  };

  const isDeConfigured = (editor) => {
    return editor?.toolSheetAccess && Object.keys(editor.toolSheetAccess).length > 0;
  };

  const toggleDeToolSheet = (toolId, sheetCode) => {
    if (!deSelectedEditorId) return;
    setDrawingEditors(prev => prev.map(de => {
      if (de.id !== deSelectedEditorId) return de;
      const tsa = { ...(de.toolSheetAccess || {}) };
      const cur = tsa[toolId] || [];
      tsa[toolId] = cur.includes(sheetCode) ? cur.filter(c => c !== sheetCode) : [...cur, sheetCode];
      return { ...de, toolSheetAccess: tsa };
    }));
    setDeMatrixDirty(true);
  };

  const toggleDeToolRow = (toolId) => {
    if (!deSelectedEditorId) return;
    const allCodes = deMatrixSheets.map(s => s.code);
    const cur = deSelectedEditor?.toolSheetAccess?.[toolId] || [];
    const allChecked = allCodes.every(c => cur.includes(c));
    setDrawingEditors(prev => prev.map(de => {
      if (de.id !== deSelectedEditorId) return de;
      const tsa = { ...(de.toolSheetAccess || {}) };
      tsa[toolId] = allChecked ? [] : [...allCodes];
      return { ...de, toolSheetAccess: tsa };
    }));
    setDeMatrixDirty(true);
  };

  const toggleDeSheetColumn = (sheetCode) => {
    if (!deSelectedEditorId) return;
    const tsa = deSelectedEditor?.toolSheetAccess || {};
    const allChecked = filteredEditorTools.every(t => (tsa[t.id] || []).includes(sheetCode));
    setDrawingEditors(prev => prev.map(de => {
      if (de.id !== deSelectedEditorId) return de;
      const newTsa = { ...(de.toolSheetAccess || {}) };
      filteredEditorTools.forEach(t => {
        const arr = newTsa[t.id] || [];
        if (allChecked) { newTsa[t.id] = arr.filter(c => c !== sheetCode); }
        else if (!arr.includes(sheetCode)) { newTsa[t.id] = [...arr, sheetCode]; }
      });
      return { ...de, toolSheetAccess: newTsa };
    }));
    setDeMatrixDirty(true);
  };

  const enableAllDeTools = () => {
    if (!deSelectedEditorId) return;
    setDrawingEditors(prev => prev.map(de => {
      if (de.id !== deSelectedEditorId) return de;
      const editorSheets = de.sheetAccess || [];
      const newTsa = {};
      filteredEditorTools.forEach(t => {
        const toolSheets = t.sheetAccess || [];
        newTsa[t.id] = toolSheets.filter(s => editorSheets.includes(s));
      });
      return { ...de, toolSheetAccess: newTsa };
    }));
    setDeMatrixDirty(true);
  };

  const saveDeToolMatrix = async () => {
    if (!deSelectedEditorId) return;
    const de = drawingEditors.find(d => d.id === deSelectedEditorId);
    const res = await apiFetch(`/drawing-editors/${deSelectedEditorId}/tool-matrix`, {
      method: 'PUT', body: JSON.stringify({ toolSheetAccess: de?.toolSheetAccess || {} })
    });
    if (res && !res._error) setDeMatrixDirty(false);
  };

  // Group tools by category for matrix
  const toolsByCategory = {};
  filteredEditorTools.forEach(t => {
    const cat = t.category || 'general';
    if (!toolsByCategory[cat]) toolsByCategory[cat] = [];
    toolsByCategory[cat].push(t);
  });
  const sortedCategories = TOOL_CAT_ORDER.filter(c => toolsByCategory[c]);

  // Get access array for a tool based on current plan + party type selection
  const getToolAcc = (tool) => {
    if (!matrixPlanId || !matrixPartyId) return [];
    const pt = partyTypes.find(p => p.id === matrixPartyId);
    return pt?.toolSheetAccess?.[matrixPlanId]?.[tool.id] || [];
  };

  // Toggle a single tool-sheet checkbox
  const toggleToolSheet = (toolId, sheetCode) => {
    if (!matrixPlanId || !matrixPartyId) return;
    const tool = editorTools.find(t => t.id === toolId);
    const ownerHas = (tool?.sheetAccess || []).includes(sheetCode);
    const pt = partyTypes.find(p => p.id === matrixPartyId);
    const cur = pt?.toolSheetAccess?.[matrixPlanId]?.[toolId] || [];
    const isChecked = cur.includes(sheetCode);
    if (!isChecked && !ownerHas) {
      if (!window.confirm('Platformda bu paftada bu araca erişim tanımlı değil. Yine de izin vermek istiyor musunuz?')) return;
    }
    setPartyTypes(prev => prev.map(p => {
      if (p.id !== matrixPartyId) return p;
      const tsa = { ...(p.toolSheetAccess || {}) };
      const planAcc = { ...(tsa[matrixPlanId] || {}) };
      const arr = planAcc[toolId] || [];
      planAcc[toolId] = isChecked ? arr.filter(c => c !== sheetCode) : [...arr, sheetCode];
      tsa[matrixPlanId] = planAcc;
      return { ...p, toolSheetAccess: tsa };
    }));
    setToolMatrixDirty(true);
  };

  // Toggle all sheets for a tool (row toggle)
  const toggleToolRow = (toolId) => {
    if (!matrixPlanId || !matrixPartyId) return;
    const allCodes = filteredSheetTypes.map(s => s.code);
    const tool = editorTools.find(t => t.id === toolId);
    const ownerAcc = tool?.sheetAccess || [];
    const pt = partyTypes.find(p => p.id === matrixPartyId);
    const cur = pt?.toolSheetAccess?.[matrixPlanId]?.[toolId] || [];
    const allChecked = allCodes.every(c => cur.includes(c));
    if (!allChecked) {
      const adding = allCodes.filter(c => !cur.includes(c));
      if (adding.some(c => !ownerAcc.includes(c))) {
        if (!window.confirm('Bazı paftalarda platform erişimi tanımlı değil. Yine de izin vermek istiyor musunuz?')) return;
      }
    }
    setPartyTypes(prev => prev.map(p => {
      if (p.id !== matrixPartyId) return p;
      const tsa = { ...(p.toolSheetAccess || {}) };
      const planAcc = { ...(tsa[matrixPlanId] || {}) };
      planAcc[toolId] = allChecked ? [] : [...allCodes];
      tsa[matrixPlanId] = planAcc;
      return { ...p, toolSheetAccess: tsa };
    }));
    setToolMatrixDirty(true);
  };

  // Toggle all tools for a sheet (column toggle)
  const toggleSheetColumn = (sheetCode) => {
    if (!matrixPlanId || !matrixPartyId) return;
    const pt = partyTypes.find(p => p.id === matrixPartyId);
    const planAcc = pt?.toolSheetAccess?.[matrixPlanId] || {};
    const allChecked = filteredEditorTools.every(t => (planAcc[t.id] || []).includes(sheetCode));
    if (!allChecked) {
      const wouldAdd = filteredEditorTools.filter(t => !(planAcc[t.id] || []).includes(sheetCode));
      if (wouldAdd.some(t => !(t.sheetAccess || []).includes(sheetCode))) {
        if (!window.confirm('Bazı araçlarda platform erişimi tanımlı değil. Yine de izin vermek istiyor musunuz?')) return;
      }
    }
    setPartyTypes(prev => prev.map(p => {
      if (p.id !== matrixPartyId) return p;
      const tsa = { ...(p.toolSheetAccess || {}) };
      const newPlanAcc = { ...(tsa[matrixPlanId] || {}) };
      filteredEditorTools.forEach(t => {
        const arr = newPlanAcc[t.id] || [];
        if (allChecked) { newPlanAcc[t.id] = arr.filter(c => c !== sheetCode); }
        else if (!arr.includes(sheetCode)) { newPlanAcc[t.id] = [...arr, sheetCode]; }
      });
      tsa[matrixPlanId] = newPlanAcc;
      return { ...p, toolSheetAccess: tsa };
    }));
    setToolMatrixDirty(true);
  };

  // Save matrix to backend
  const saveToolMatrix = async () => {
    if (!matrixPlanId || !matrixPartyId) return;
    const pt = partyTypes.find(p => p.id === matrixPartyId);
    const toolAccess = pt?.toolSheetAccess?.[matrixPlanId] || {};
    const res = await apiFetch(`/party-types/${matrixPartyId}/tool-matrix`, {
      method: 'PUT', body: JSON.stringify({ planId: matrixPlanId, toolAccess })
    });
    if (res && !res._error) setToolMatrixDirty(false);
  };

  const matrixPlanLabel = plans.find(p => p.id === matrixPlanId)?.name || '';
  const matrixPartyLabel = partyTypes.find(p => p.id === matrixPartyId)?.name || '';
  const matrixTargetLabel = matrixPlanLabel && matrixPartyLabel
    ? `${matrixPlanLabel} — ${matrixPartyLabel}`
    : '';

  const renderDisciplines = () => (
    <div className="adm-disc-layout">
      {/* Discipline selector */}
      <div className="adm-disc-selector">
        <div className="adm-disc-list">
          {disciplines.map(d => (
            <button key={d.id} className={`adm-disc-item ${selectedDiscipline?.id === d.id ? 'active' : ''}`}
              onClick={() => { setSelectedDiscipline(d); setDiscTab('overview'); }}>
              <span className="adm-disc-item-name">{d.name}</span>
              <span className="adm-disc-item-stats">{d.sheetTypeCount} pafta · {d.partyTypeCount} paydaş</span>
            </button>
          ))}
        </div>
        <button className="adm-btn primary adm-disc-add" onClick={() => setModal({
          type: 'discipline', editing: false,
          data: { code: '', name: '', icon: 'layers' }
        })}>+ Yeni Disiplin</button>
      </div>

      {/* Discipline content */}
      {selectedDiscipline ? (
        <div className="adm-disc-content">
          <div className="adm-disc-tabs">
            {[
              { id: 'overview', label: 'Genel' },
              { id: 'sheets', label: `Pafta Tipleri (${filteredSheetTypes.length})` },
              { id: 'parties', label: `Paydaş Tipleri (${filteredPartyTypes.length})` },
              { id: 'editors', label: `Çizim Editörleri (${filteredDrawingEditors.length})` },
              { id: 'tools', label: `Editör Araçları (${filteredEditorTools.length})` },
            ].map(t => (
              <button key={t.id} className={`adm-disc-tab ${discTab === t.id ? 'active' : ''}`} onClick={() => setDiscTab(t.id)}>{t.label}</button>
            ))}
          </div>

          {discTab === 'overview' && (
            <div className="adm-disc-overview">
              <div className="adm-detail-grid">
                <div className="adm-detail-card">
                  <h3>Disiplin Bilgileri</h3>
                  <div className="adm-detail-rows">
                    <div className="adm-detail-row"><span>Kod</span><span className="adm-badge">{selectedDiscipline.code}</span></div>
                    <div className="adm-detail-row"><span>Ad</span><span>{selectedDiscipline.name}</span></div>
                    <div className="adm-detail-row"><span>Durum</span><span className={`adm-badge ${selectedDiscipline.isActive ? 'green' : ''}`}>{selectedDiscipline.isActive ? 'Aktif' : 'Pasif'}</span></div>
                  </div>
                </div>
                <div className="adm-detail-card">
                  <h3>İstatistikler</h3>
                  <div className="adm-detail-rows">
                    <div className="adm-detail-row"><span>Pafta Tipleri</span><span className="adm-badge blue">{filteredSheetTypes.length}</span></div>
                    <div className="adm-detail-row"><span>Paydaş Tipleri</span><span className="adm-badge green">{filteredPartyTypes.length}</span></div>
                    <div className="adm-detail-row"><span>Çizim Editörleri</span><span className="adm-badge purple">{filteredDrawingEditors.length}</span></div>
                    <div className="adm-detail-row"><span>Editör Araçları</span><span className="adm-badge orange">{filteredEditorTools.length}</span></div>
                  </div>
                </div>
              </div>
              <div className="adm-disc-actions-bar">
                <button className="adm-btn" onClick={() => setModal({ type: 'discipline', editing: true, data: { ...selectedDiscipline } })}><SvgIcon name="edit" size={14} /> Düzenle</button>
              </div>
            </div>
          )}

          {discTab === 'sheets' && (
            <>
              <div className="adm-toolbar">
                <span className="adm-toolbar-info">{filteredSheetTypes.length} pafta tipi</span>
                <button className="adm-btn primary" onClick={() => setModal({
                  type: 'sheet-type', editing: false,
                  data: { disciplineId: selectedDiscipline.id, code: '', name: '' }
                })}>+ Yeni Pafta Tipi</button>
              </div>
              <div className="adm-table-wrap">
                <table className="adm-table">
                  <thead><tr><th>Sıra</th><th>Kod</th><th>Ad</th><th>İşlem</th></tr></thead>
                  <tbody>
                    {filteredSheetTypes.map(s => (
                      <tr key={s.id}>
                        <td>{s.order}</td>
                        <td><span className="adm-badge">{s.code}</span></td>
                        <td>{s.name}</td>
                        <td>
                          <div className="adm-actions">
                            <button className="adm-btn-sm" onClick={() => setModal({ type: 'sheet-type', editing: true, data: { ...s } })} title="Düzenle"><SvgIcon name="edit" size={14} /></button>
                            <button className="adm-btn-sm danger" onClick={() => handleDelete('sheet-types', s.id, setSheetTypes)} title="Sil"><SvgIcon name="trash" size={14} /></button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filteredSheetTypes.length === 0 && <div className="adm-empty">Pafta tipi tanımlanmamış.</div>}
              </div>
            </>
          )}

          {discTab === 'parties' && (
            <>
              {/* ─── Global Paydaş Kategorileri (Sektör Rolleri) ─── */}
              <div className="adm-party-cat-panel">
                <div className="adm-party-cat-header">
                  <div>
                    <h4>Global Paydaş Kategorileri</h4>
                    <span className="adm-party-cat-hint">Tüm disiplinlerde ortak kullanılan sektör rolleri. Bu kategoriler kullanıcı ayarlarındaki "Sektör Rolü" dropdown'unda da görünür.</span>
                  </div>
                  <button className="adm-btn primary adm-btn-sm" onClick={() => setModal({
                    type: 'party-category', editing: false,
                    data: { key: '', name: '', order: (partyCategories.length + 1) * 10 }
                  })}>+ Yeni Kategori</button>
                </div>
                <div className="adm-party-cat-list">
                  {partyCategories.sort((a, b) => (a.order || 0) - (b.order || 0)).map(c => (
                    <div key={c.id} className={`adm-party-cat-chip ${!c.isActive ? 'inactive' : ''}`}>
                      <span className="adm-party-cat-name">{c.name}</span>
                      <span className="adm-party-cat-key">{c.key}</span>
                      <div className="adm-actions">
                        <button className="adm-btn-sm" onClick={() => setModal({ type: 'party-category', editing: true, data: { ...c } })} title="Düzenle"><SvgIcon name="edit" size={12} /></button>
                        <button className="adm-btn-sm danger" onClick={async () => {
                          if (!window.confirm(`"${c.name}" kategorisini silmek istiyor musunuz?`)) return;
                          const res = await apiFetch(`/party-categories/${c.id}`, { method: 'DELETE' });
                          if (res && !res._error) setPartyCategories(prev => prev.filter(x => x.id !== c.id));
                        }} title="Sil"><SvgIcon name="trash" size={12} /></button>
                      </div>
                    </div>
                  ))}
                  {partyCategories.length === 0 && <div className="adm-empty">Kategori tanımlanmamış.</div>}
                </div>
              </div>

              <div className="adm-toolbar">
                <span className="adm-toolbar-info">{filteredPartyTypes.length} paydaş tipi</span>
                <button className="adm-btn primary" onClick={() => setModal({
                  type: 'party-type', editing: false,
                  data: { disciplineId: selectedDiscipline.id, code: '', name: '', category: '', isProjectOwner: false, defaultEditorAccess: 'view', defaultSheetAccess: ['*'] }
                })}>+ Yeni Paydaş Tipi</button>
              </div>
              <div className="adm-party-grid">
                {filteredPartyTypes.map(p => (
                  <div className={`adm-party-card ${p.category}`} key={p.id}>
                    <div className="adm-party-header">
                      <h4>{p.name}</h4>
                      <span className={`adm-badge ${PARTY_CATEGORY_COLOR[p.category] || 'gray'}`}>
                        {partyCategories.find(c => c.key === p.category)?.name
                          || PARTY_CATEGORIES.find(c => c.value === p.category)?.label
                          || p.category}
                      </span>
                    </div>
                    {p.isProjectOwner && <div className="adm-party-owner-badge">Proje Sahibi</div>}
                    <div className="adm-party-details">
                      <div className="adm-party-detail">
                        <span className="adm-party-detail-label">Editör Erişimi</span>
                        <span className={`adm-badge ${p.defaultEditorAccess === 'full' ? 'green' : p.defaultEditorAccess === 'annotate' ? 'orange' : ''}`}>
                          {EDITOR_ACCESS_LEVELS.find(l => l.value === p.defaultEditorAccess)?.label || p.defaultEditorAccess}
                        </span>
                      </div>
                      <div className="adm-party-detail">
                        <span className="adm-party-detail-label">Pafta Erişimi</span>
                        <div className="adm-party-sheets">
                          {(p.sheetNames || p.defaultSheetAccess).map((s, i) => (
                            <span key={i} className="adm-badge">{s === '*' ? 'Tümü' : s}</span>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="adm-party-actions">
                      <button className="adm-btn-sm" onClick={() => setModal({ type: 'party-type', editing: true, data: { ...p } })} title="Düzenle"><SvgIcon name="edit" size={14} /></button>
                      <button className="adm-btn-sm danger" onClick={() => handleDelete('party-types', p.id, setPartyTypes)} title="Sil"><SvgIcon name="trash" size={14} /></button>
                    </div>
                  </div>
                ))}
              </div>
              {filteredPartyTypes.length === 0 && <div className="adm-empty">Paydaş tipi tanımlanmamış.</div>}
            </>
          )}

          {discTab === 'editors' && (
            <>
              <div className="adm-toolbar">
                <span className="adm-toolbar-info">{filteredDrawingEditors.length} çizim editörü</span>
                <button className="adm-btn primary" onClick={() => setModal({
                  type: 'drawing-editor', editing: false,
                  data: { code: '', name: '', description: '', sheetAccess: [], disciplineId: selectedDiscipline?.id }
                })}>+ Yeni Çizim Editörü</button>
              </div>
              <div className="adm-de-grid">
                {filteredDrawingEditors.map(de => (
                  <div className={`adm-de-card ${de.isActive ? '' : 'inactive'} ${deSelectedEditorId === de.id ? 'selected' : ''}`} key={de.id}
                    onClick={() => {
                      if (deMatrixDirty && !window.confirm('Kaydedilmemiş değişiklikler var. Devam etmek istiyor musunuz?')) return;
                      setDeSelectedEditorId(deSelectedEditorId === de.id ? null : de.id);
                      setDeMatrixDirty(false);
                    }}
                    style={{ cursor: 'pointer' }}>
                    <div className="adm-de-card-header">
                      <div className="adm-de-card-title">{de.name}</div>
                      <div style={{ display: 'flex', gap: '.3rem', alignItems: 'center' }}>
                        {isDeConfigured(de) && <span className="adm-badge purple">Yapılandırıldı</span>}
                        <span className={`adm-badge ${de.isActive ? 'green' : ''}`}>{de.isActive ? 'Aktif' : 'Pasif'}</span>
                      </div>
                    </div>
                    {de.description && <div className="adm-de-card-desc">{de.description}</div>}
                    <div className="adm-de-card-sheets">
                      <span className="adm-de-card-sheets-label">Paftalar:</span>
                      {(de.sheetAccess || []).map(code => {
                        const sheet = filteredSheetTypes.find(s => s.code === code);
                        return <span key={code} className="adm-badge">{sheet?.name || code}</span>;
                      })}
                      {(!de.sheetAccess || de.sheetAccess.length === 0) && <span className="adm-muted">Tanımsız</span>}
                    </div>
                    <div className="adm-de-card-actions" onClick={e => e.stopPropagation()}>
                      <button className="adm-btn-sm" onClick={() => setModal({ type: 'drawing-editor', editing: true, data: { ...de } })} title="Düzenle"><SvgIcon name="edit" size={14} /></button>
                      <button className="adm-btn-sm danger" onClick={() => handleDelete('drawing-editors', de.id, setDrawingEditors)} title="Sil"><SvgIcon name="trash" size={14} /></button>
                    </div>
                  </div>
                ))}
              </div>
              {filteredDrawingEditors.length === 0 && <div className="adm-empty">Çizim editörü tanımlanmamış.</div>}

              {/* Drawing Editor Tool Matrix */}
              {deSelectedEditor && (
                <div style={{ marginTop: '1.25rem' }}>
                  <div className="adm-toolbar">
                    <span className="adm-toolbar-info" style={{ fontWeight: 700 }}>
                      <span className="adm-badge purple" style={{ marginRight: 8, fontSize: '.78rem' }}>{deSelectedEditor.name}</span>
                      Araç-Pafta Erişim Matrisi
                    </span>
                    {!isDeConfigured(deSelectedEditor) && (
                      <button className="adm-btn" onClick={enableAllDeTools}>Tüm Araçları Etkinleştir</button>
                    )}
                    {deMatrixDirty && (
                      <button className="adm-btn primary" onClick={saveDeToolMatrix}>Matrisi Kaydet</button>
                    )}
                  </div>
                  {deMatrixSheets.length > 0 && filteredEditorTools.length > 0 ? (
                    <div className="adm-matrix-wrap">
                      <table className="adm-matrix">
                        <thead>
                          <tr>
                            <th className="adm-matrix-tool-th">Editör Aracı</th>
                            {deMatrixSheets.map(s => (
                              <th key={s.id} className="adm-matrix-sheet-th">
                                <span className="adm-matrix-sheet-name">{s.name}</span>
                                <label className="adm-matrix-col-toggle" title="Tümünü aç/kapat">
                                  <input type="checkbox"
                                    checked={filteredEditorTools.every(t => (deSelectedEditor.toolSheetAccess?.[t.id] || []).includes(s.code))}
                                    onChange={() => toggleDeSheetColumn(s.code)} />
                                  <span className="adm-matrix-toggle-box" />
                                </label>
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {sortedCategories.map(cat => (
                            <React.Fragment key={cat}>
                              <tr className="adm-matrix-cat-row">
                                <td colSpan={deMatrixSheets.length + 1}>{TOOL_CATEGORIES[cat] || cat}</td>
                              </tr>
                              {toolsByCategory[cat].map(t => {
                                const ownerAcc = t.sheetAccess || [];
                                const deAcc = getDeToolAcc(t);
                                const allChecked = deMatrixSheets.every(s => deAcc.includes(s.code));
                                return (
                                  <tr key={t.id} className="adm-matrix-tool-row">
                                    <td className="adm-matrix-tool-cell">
                                      <div className="adm-matrix-tool-info">
                                        <strong>{t.name}</strong>
                                        <span>{t.description}</span>
                                      </div>
                                      <label className="adm-matrix-row-toggle" title="Tüm paftalarda aç/kapat">
                                        <input type="checkbox" checked={allChecked} onChange={() => toggleDeToolRow(t.id)} />
                                        <span className="adm-matrix-toggle-box" />
                                      </label>
                                    </td>
                                    {deMatrixSheets.map(s => {
                                      const platformBlocked = !ownerAcc.includes(s.code);
                                      return (
                                        <td key={s.id} className={`adm-matrix-cell ${deAcc.includes(s.code) ? 'on' : ''} ${platformBlocked ? 'owner-blocked' : ''}`}>
                                          <label className="adm-matrix-check" title={platformBlocked ? 'Bu araç bu paftada platform erişimine sahip değil' : ''}>
                                            <input type="checkbox" checked={deAcc.includes(s.code)} onChange={() => toggleDeToolSheet(t.id, s.code)} />
                                            <span className="adm-matrix-check-box" />
                                          </label>
                                        </td>
                                      );
                                    })}
                                  </tr>
                                );
                              })}
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="adm-empty">Bu editör için pafta veya araç tanımlanmamış.</div>
                  )}
                </div>
              )}
            </>
          )}

          {discTab === 'tools' && (
            <>
              <div className="adm-toolbar">
                <div className="adm-matrix-selects">
                  <div className="adm-matrix-select-group">
                    <label className="adm-matrix-select-label">Çizim Editörü</label>
                    <select className="adm-select-target" value={matrixEditorId || ''} onChange={e => {
                      if (toolMatrixDirty && !window.confirm('Kaydedilmemiş değişiklikler var. Devam etmek istiyor musunuz?')) return;
                      setMatrixEditorId(e.target.value || null);
                      setToolMatrixDirty(false);
                    }}>
                      <option value="">Tümü (filtre yok)</option>
                      {filteredDrawingEditors.filter(de => de.isActive).map(de => (
                        <option key={de.id} value={de.id}>{de.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="adm-matrix-select-group">
                    <label className="adm-matrix-select-label">Abonelik Tipleri</label>
                    <select className="adm-select-target" value={matrixPlanId || ''} onChange={e => {
                      if (toolMatrixDirty && !window.confirm('Kaydedilmemiş değişiklikler var. Devam etmek istiyor musunuz?')) return;
                      setMatrixPlanId(e.target.value || null);
                      setToolMatrixDirty(false);
                    }}>
                      <option value="">Plan seçin...</option>
                      {plans.filter(p => p.isActive).map(p => (
                        <option key={p.id} value={p.id}>{p.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="adm-matrix-select-group">
                    <label className="adm-matrix-select-label">Paydaşlar</label>
                    <select className="adm-select-target" value={matrixPartyId || ''} onChange={e => {
                      if (toolMatrixDirty && !window.confirm('Kaydedilmemiş değişiklikler var. Devam etmek istiyor musunuz?')) return;
                      setMatrixPartyId(e.target.value || null);
                      setToolMatrixDirty(false);
                    }}>
                      <option value="">Paydaş seçin...</option>
                      {filteredPartyTypes.map(p => (
                        <option key={p.id} value={p.id}>{p.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <span className="adm-toolbar-info">
                  {filteredEditorTools.length} araç · {matrixSheetTypes.length} pafta tipi
                  {selectedDrawingEditor && <span className="adm-badge purple" style={{marginLeft: 8}}>{selectedDrawingEditor.name}</span>}
                </span>
                {toolMatrixDirty && matrixPlanId && matrixPartyId && (
                  <button className="adm-btn primary" onClick={saveToolMatrix}>
                    {matrixTargetLabel} erişim ayarlarını Kaydet
                  </button>
                )}
              </div>
              {(!matrixPlanId || !matrixPartyId) && (
                <div className="adm-empty">Erişim matrisini görüntülemek için bir abonelik tipi ve paydaş seçin.</div>
              )}
              {matrixPlanId && matrixPartyId && filteredEditorTools.length > 0 && matrixSheetTypes.length > 0 ? (
                <div className="adm-matrix-wrap">
                  <table className="adm-matrix">
                    <thead>
                      <tr>
                        <th className="adm-matrix-tool-th">Editör Aracı</th>
                        {matrixSheetTypes.map(s => {
                          const editorBlocked = selectedDrawingEditor && !(selectedDrawingEditor.sheetAccess || []).includes(s.code);
                          return (
                            <th key={s.id} className={`adm-matrix-sheet-th ${editorBlocked ? 'editor-blocked' : ''}`}>
                              <span className="adm-matrix-sheet-name">{s.name}</span>
                              <label className="adm-matrix-col-toggle" title="Tümünü aç/kapat">
                                <input type="checkbox"
                                  checked={matrixPlanId && matrixPartyId && filteredEditorTools.every(t => {
                                    const pt = partyTypes.find(p => p.id === matrixPartyId);
                                    return (pt?.toolSheetAccess?.[matrixPlanId]?.[t.id] || []).includes(s.code);
                                  })}
                                  disabled={!matrixPlanId || !matrixPartyId}
                                  onChange={() => toggleSheetColumn(s.code)} />
                                <span className="adm-matrix-toggle-box" />
                              </label>
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {sortedCategories.map(cat => (
                        <React.Fragment key={cat}>
                          <tr className="adm-matrix-cat-row">
                            <td colSpan={matrixSheetTypes.length + 1}>{TOOL_CATEGORIES[cat] || cat}</td>
                          </tr>
                          {toolsByCategory[cat].map(t => {
                            const ownerAcc = t.sheetAccess || [];
                            const acc = getToolAcc(t);
                            const editorTsa = selectedDrawingEditor?.toolSheetAccess || {};
                            const editorConfigured = selectedDrawingEditor && Object.keys(editorTsa).length > 0;
                            const allChecked = matrixSheetTypes.every(s => acc.includes(s.code));
                            return (
                              <tr key={t.id} className="adm-matrix-tool-row">
                                <td className="adm-matrix-tool-cell">
                                  <div className="adm-matrix-tool-info">
                                    <strong>{t.name}</strong>
                                    <span>{t.description}</span>
                                  </div>
                                  <label className="adm-matrix-row-toggle" title="Tüm paftalarda aç/kapat">
                                    <input type="checkbox" checked={allChecked} disabled={!matrixPlanId || !matrixPartyId} onChange={() => toggleToolRow(t.id)} />
                                    <span className="adm-matrix-toggle-box" />
                                  </label>
                                </td>
                                {matrixSheetTypes.map(s => {
                                  const platformBlocked = !ownerAcc.includes(s.code);
                                  const editorBlocked = editorConfigured && !(editorTsa[t.id] || []).includes(s.code);
                                  return (
                                    <td key={s.id} className={`adm-matrix-cell ${acc.includes(s.code) ? 'on' : ''} ${platformBlocked ? 'owner-blocked' : ''} ${editorBlocked ? 'editor-blocked' : ''}`}>
                                      <label className="adm-matrix-check" title={editorBlocked ? 'Bu araç çizim editöründe yapılandırılmamış' : platformBlocked ? 'Platform erişimi tanımlı değil' : ''}>
                                        <input type="checkbox" checked={acc.includes(s.code)} disabled={!matrixPlanId || !matrixPartyId || editorBlocked} onChange={() => toggleToolSheet(t.id, s.code)} />
                                        <span className="adm-matrix-check-box" />
                                      </label>
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="adm-empty">Editör aracı veya pafta tipi tanımlanmamış.</div>
              )}
            </>
          )}
        </div>
      ) : (
        <div className="adm-empty" style={{ flex: 1 }}>Bir disiplin seçin veya yeni bir disiplin ekleyin.</div>
      )}

      {/* Discipline modals */}
      {modal?.type === 'discipline' && (
        <div className="adm-modal-backdrop" onClick={() => setModal(null)}>
          <div className="adm-modal" onClick={e => e.stopPropagation()}>
            <h3>{modal.editing ? 'Disiplin Düzenle' : 'Yeni Disiplin'}</h3>
            <div className="adm-modal-form">
              <input placeholder="Kod (ör: mechanical)" value={modal.data.code} onChange={e => setModal(m => ({ ...m, data: { ...m.data, code: e.target.value } }))} disabled={modal.editing} />
              <input placeholder="Ad (ör: Mekanik)" value={modal.data.name} onChange={e => setModal(m => ({ ...m, data: { ...m.data, name: e.target.value } }))} />
            </div>
            <div className="adm-modal-actions">
              <button className="adm-btn" onClick={() => setModal(null)}>İptal</button>
              <button className="adm-btn primary" onClick={async () => {
                const d = modal.data;
                if (!d.code || !d.name) return;
                if (modal.editing) {
                  const res = await apiFetch(`/disciplines/${d.id}`, { method: 'PUT', body: JSON.stringify(d) });
                  if (res && !res._error) { setDisciplines(prev => prev.map(x => x.id === d.id ? { ...x, ...d } : x)); setSelectedDiscipline(prev => prev?.id === d.id ? { ...prev, ...d } : prev); }
                } else {
                  const res = await apiFetch('/disciplines', { method: 'POST', body: JSON.stringify(d) });
                  if (res && !res._error) { setDisciplines(prev => [...prev, { ...res.discipline, sheetTypeCount: 0, partyTypeCount: 0, toolCount: 0 }]); setSelectedDiscipline(res.discipline); }
                }
                setModal(null);
              }}>{modal.editing ? 'Güncelle' : 'Oluştur'}</button>
            </div>
          </div>
        </div>
      )}

      {modal?.type === 'sheet-type' && (
        <div className="adm-modal-backdrop" onClick={() => setModal(null)}>
          <div className="adm-modal" onClick={e => e.stopPropagation()}>
            <h3>{modal.editing ? 'Pafta Tipi Düzenle' : 'Yeni Pafta Tipi'}</h3>
            <div className="adm-modal-form">
              <input placeholder="Kod (ör: lighting)" value={modal.data.code} onChange={e => setModal(m => ({ ...m, data: { ...m.data, code: e.target.value } }))} />
              <input placeholder="Ad (ör: Aydınlatma)" value={modal.data.name} onChange={e => setModal(m => ({ ...m, data: { ...m.data, name: e.target.value } }))} />
            </div>
            <div className="adm-modal-actions">
              <button className="adm-btn" onClick={() => setModal(null)}>İptal</button>
              <button className="adm-btn primary" onClick={async () => {
                const d = modal.data;
                if (!d.code || !d.name) return;
                if (modal.editing) {
                  const res = await apiFetch(`/sheet-types/${d.id}`, { method: 'PUT', body: JSON.stringify(d) });
                  if (res && !res._error) setSheetTypes(prev => prev.map(x => x.id === d.id ? { ...x, ...d } : x));
                } else {
                  const res = await apiFetch('/sheet-types', { method: 'POST', body: JSON.stringify(d) });
                  if (res && !res._error) setSheetTypes(prev => [...prev, res.sheetType]);
                }
                setModal(null);
              }}>{modal.editing ? 'Güncelle' : 'Oluştur'}</button>
            </div>
          </div>
        </div>
      )}

      {modal?.type === 'drawing-editor' && (
        <div className="adm-modal-backdrop" onClick={() => setModal(null)}>
          <div className="adm-modal adm-modal-lg" onClick={e => e.stopPropagation()}>
            <h3>{modal.editing ? 'Çizim Editörü Düzenle' : 'Yeni Çizim Editörü'}</h3>
            <div className="adm-modal-form">
              <div className="adm-form-row">
                <input placeholder="Kod (ör: mesken)" value={modal.data.code} onChange={e => setModal(m => ({ ...m, data: { ...m.data, code: e.target.value } }))} disabled={modal.editing} />
                <input placeholder="Ad (ör: Mesken)" value={modal.data.name} onChange={e => setModal(m => ({ ...m, data: { ...m.data, name: e.target.value } }))} />
              </div>
              <input placeholder="Açıklama (opsiyonel)" value={modal.data.description || ''} onChange={e => setModal(m => ({ ...m, data: { ...m.data, description: e.target.value } }))} />
              {modal.editing && (
                <label className="adm-perm-check">
                  <input type="checkbox" checked={modal.data.isActive !== false} onChange={e => setModal(m => ({ ...m, data: { ...m.data, isActive: e.target.checked } }))} />
                  <span className="adm-perm-check-box" />
                  <span>Aktif</span>
                </label>
              )}
              <h4 className="adm-form-subtitle">Pafta Erişimi</h4>
              <div className="adm-sheet-access-grid">
                {filteredSheetTypes.map(s => (
                  <label className="adm-perm-check" key={s.id}>
                    <input type="checkbox" checked={(modal.data.sheetAccess || []).includes(s.code)} onChange={e => {
                      const arr = modal.data.sheetAccess || [];
                      setModal(m => ({
                        ...m, data: {
                          ...m.data,
                          sheetAccess: e.target.checked ? [...arr, s.code] : arr.filter(x => x !== s.code)
                        }
                      }));
                    }} />
                    <span className="adm-perm-check-box" />
                    <span>{s.name}</span>
                  </label>
                ))}
              </div>
            </div>
            <div className="adm-modal-actions">
              <button className="adm-btn" onClick={() => setModal(null)}>İptal</button>
              <button className="adm-btn primary" onClick={async () => {
                const d = modal.data;
                if (!d.code || !d.name) return;
                if (modal.editing) {
                  const res = await apiFetch(`/drawing-editors/${d.id}`, { method: 'PUT', body: JSON.stringify(d) });
                  if (res && !res._error) {
                    setDrawingEditors(prev => prev.map(x => x.id === d.id ? { ...x, ...d } : x));
                  } else {
                    alert(res?.message || 'Güncelleme başarısız.');
                    return;
                  }
                } else {
                  const payload = { ...d, disciplineId: selectedDiscipline?.id };
                  const res = await apiFetch('/drawing-editors', { method: 'POST', body: JSON.stringify(payload) });
                  if (res && !res._error) {
                    setDrawingEditors(prev => [...prev, res.drawingEditor]);
                  } else {
                    alert(res?.message || 'Oluşturma başarısız. Backend sunucusunu kontrol edin.');
                    return;
                  }
                }
                setModal(null);
              }}>{modal.editing ? 'Güncelle' : 'Oluştur'}</button>
            </div>
          </div>
        </div>
      )}

      {modal?.type === 'party-type' && (
        <div className="adm-modal-backdrop" onClick={() => setModal(null)}>
          <div className="adm-modal adm-modal-lg" onClick={e => e.stopPropagation()}>
            <h3>{modal.editing ? 'Paydaş Tipi Düzenle' : 'Yeni Paydaş Tipi'}</h3>
            <div className="adm-modal-form">
              <div className="adm-form-row">
                <input placeholder="Kod (ör: inspector)" value={modal.data.code} onChange={e => setModal(m => ({ ...m, data: { ...m.data, code: e.target.value } }))} />
                <input placeholder="Ad (ör: Müfettiş)" value={modal.data.name} onChange={e => setModal(m => ({ ...m, data: { ...m.data, name: e.target.value } }))} />
              </div>
              <div className="adm-form-row">
                <label className="adm-form-label">Kategori
                  <select value={modal.data.category} onChange={e => setModal(m => ({ ...m, data: { ...m.data, category: e.target.value } }))}>
                    <option value="">Seçin...</option>
                    {partyCategories.filter(c => c.isActive !== false).map(c => (
                      <option key={c.id} value={c.key}>{c.name}</option>
                    ))}
                    {/* Legacy — veritabanındakilere ek eski değerler */}
                    {['producer', 'client', 'authority'].filter(k => !partyCategories.some(c => c.key === k)).map(k => (
                      <option key={k} value={k}>{k} (eski)</option>
                    ))}
                  </select>
                </label>
                <label className="adm-form-label">Editör Erişim Seviyesi
                  <select value={modal.data.defaultEditorAccess} onChange={e => setModal(m => ({ ...m, data: { ...m.data, defaultEditorAccess: e.target.value } }))}>
                    {EDITOR_ACCESS_LEVELS.map(l => <option key={l.value} value={l.value}>{l.label}</option>)}
                  </select>
                </label>
              </div>
              <label className="adm-perm-check">
                <input type="checkbox" checked={modal.data.isProjectOwner || false} onChange={e => setModal(m => ({ ...m, data: { ...m.data, isProjectOwner: e.target.checked } }))} />
                <span className="adm-perm-check-box" />
                <span>Proje Sahibi (Bu paydaş tipi projeyi oluşturan paydaştır)</span>
              </label>
              <h4 className="adm-form-subtitle">Pafta Erişimi</h4>
              <div className="adm-sheet-access-grid">
                <label className="adm-perm-check">
                  <input type="checkbox" checked={modal.data.defaultSheetAccess?.includes('*')} onChange={e => {
                    if (e.target.checked) {
                      setModal(m => ({ ...m, data: { ...m.data, defaultSheetAccess: ['*'] } }));
                    } else {
                      setModal(m => ({ ...m, data: { ...m.data, defaultSheetAccess: [] } }));
                    }
                  }} />
                  <span className="adm-perm-check-box" />
                  <span>Tüm Paftalar</span>
                </label>
                {!modal.data.defaultSheetAccess?.includes('*') && filteredSheetTypes.map(s => (
                  <label className="adm-perm-check" key={s.id}>
                    <input type="checkbox" checked={modal.data.defaultSheetAccess?.includes(s.code)} onChange={e => {
                      const arr = modal.data.defaultSheetAccess || [];
                      setModal(m => ({
                        ...m, data: {
                          ...m.data,
                          defaultSheetAccess: e.target.checked ? [...arr, s.code] : arr.filter(x => x !== s.code)
                        }
                      }));
                    }} />
                    <span className="adm-perm-check-box" />
                    <span>{s.name}</span>
                  </label>
                ))}
              </div>
            </div>
            <div className="adm-modal-actions">
              <button className="adm-btn" onClick={() => setModal(null)}>İptal</button>
              <button className="adm-btn primary" onClick={async () => {
                const d = modal.data;
                if (!d.code || !d.name) return;
                if (modal.editing) {
                  const res = await apiFetch(`/party-types/${d.id}`, { method: 'PUT', body: JSON.stringify(d) });
                  if (res && !res._error) setPartyTypes(prev => prev.map(x => x.id === d.id ? { ...x, ...d } : x));
                } else {
                  const res = await apiFetch('/party-types', { method: 'POST', body: JSON.stringify(d) });
                  if (res && !res._error) setPartyTypes(prev => [...prev, res.partyType]);
                }
                setModal(null);
              }}>{modal.editing ? 'Güncelle' : 'Oluştur'}</button>
            </div>
          </div>
        </div>
      )}

      {modal?.type === 'party-category' && (
        <div className="adm-modal-backdrop" onClick={() => setModal(null)}>
          <div className="adm-modal" onClick={e => e.stopPropagation()}>
            <h3>{modal.editing ? 'Kategori Düzenle' : 'Yeni Paydaş Kategorisi'}</h3>
            <div className="adm-modal-form">
              <label className="adm-form-label">Key (kod)
                <input placeholder="örn: muellif" value={modal.data.key} onChange={e => setModal(m => ({ ...m, data: { ...m.data, key: e.target.value } }))} />
              </label>
              <label className="adm-form-label">Ad
                <input placeholder="örn: Müellif" value={modal.data.name} onChange={e => setModal(m => ({ ...m, data: { ...m.data, name: e.target.value } }))} />
              </label>
              <label className="adm-form-label">Sıra
                <input type="number" value={modal.data.order || 0} onChange={e => setModal(m => ({ ...m, data: { ...m.data, order: Number(e.target.value) } }))} />
              </label>
              {modal.editing && (
                <label className="adm-perm-check">
                  <input type="checkbox" checked={modal.data.isActive !== false} onChange={e => setModal(m => ({ ...m, data: { ...m.data, isActive: e.target.checked } }))} />
                  <span className="adm-perm-check-box" />
                  <span>Aktif</span>
                </label>
              )}
            </div>
            <div className="adm-modal-actions">
              <button className="adm-btn" onClick={() => setModal(null)}>İptal</button>
              <button className="adm-btn primary" onClick={async () => {
                const d = modal.data;
                if (!d.key || !d.name) return;
                if (modal.editing) {
                  const res = await apiFetch(`/party-categories/${d.id}`, { method: 'PUT', body: JSON.stringify(d) });
                  if (res && !res._error) setPartyCategories(prev => prev.map(x => x.id === d.id ? res.item : x));
                } else {
                  const res = await apiFetch('/party-categories', { method: 'POST', body: JSON.stringify(d) });
                  if (res && !res._error) setPartyCategories(prev => [...prev, res.item]);
                  else if (res?.message) alert(res.message);
                }
                setModal(null);
              }}>{modal.editing ? 'Güncelle' : 'Oluştur'}</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );

  /* ═══════════════════════════════════════════════
     RENDER — System Roles
     ═══════════════════════════════════════════════ */
  const PERM_LABELS = {
    admin_panel: 'Admin Paneli', manage_users: 'Kullanıcı Yönetimi',
    manage_plans: 'Plan Yönetimi', manage_disciplines: 'Disiplin Yönetimi',
    manage_content: 'İçerik Yönetimi', manage_settings: 'Sistem Ayarları'
  };

  const renderSystemRoles = () => (
    <>
      <div className="adm-toolbar">
        <span className="adm-toolbar-info">{systemRoles.length} sistem rolü</span>
        <button className="adm-btn primary" onClick={() => setModal({
          type: 'system-role', editing: false,
          data: { code: '', name: '', description: '', platformPermissions: { ...permTemplate } }
        })}>+ Yeni Rol</button>
      </div>
      <div className="adm-roles-grid">
        {systemRoles.map(role => (
          <div className={`adm-role-card ${role.isSystem ? 'system' : ''}`} key={role.id}>
            <div className="adm-role-card-header">
              <div>
                <div className="adm-role-name">{role.name}{role.isSystem && <span className="adm-badge purple">Sistem</span>}</div>
                <div className="adm-role-desc">{role.description}</div>
              </div>
              <div className="adm-role-user-count"><SvgIcon name="users" size={14} />{role.userCount}</div>
            </div>
            <div className="adm-role-perms">
              {Object.entries(role.platformPermissions || {}).map(([key, val]) => (
                <div className="adm-role-perm-row" key={key}>
                  <span className="adm-role-perm-module">{PERM_LABELS[key] || key}</span>
                  <span className={`adm-perm-dot ${val ? 'on' : ''}`} />
                </div>
              ))}
            </div>
            <div className="adm-role-card-actions">
              <button className="adm-btn-sm" onClick={() => setModal({ type: 'system-role', editing: true, data: { ...role } })} title="Düzenle"><SvgIcon name="edit" size={14} /></button>
              {!role.isSystem && <button className="adm-btn-sm danger" onClick={() => handleDelete('system-roles', role.id, setSystemRoles)} title="Sil"><SvgIcon name="trash" size={14} /></button>}
            </div>
          </div>
        ))}
      </div>

      {modal?.type === 'system-role' && (
        <div className="adm-modal-backdrop" onClick={() => setModal(null)}>
          <div className="adm-modal adm-modal-lg" onClick={e => e.stopPropagation()}>
            <h3>{modal.editing ? 'Rol Düzenle' : 'Yeni Sistem Rolü'}</h3>
            <div className="adm-modal-form">
              <div className="adm-form-row">
                <input placeholder="Kod (ör: support)" value={modal.data.code} onChange={e => setModal(m => ({ ...m, data: { ...m.data, code: e.target.value } }))} disabled={modal.editing && modal.data.isSystem} />
                <input placeholder="Ad (ör: Destek)" value={modal.data.name} onChange={e => setModal(m => ({ ...m, data: { ...m.data, name: e.target.value } }))} />
              </div>
              <input placeholder="Açıklama" value={modal.data.description} onChange={e => setModal(m => ({ ...m, data: { ...m.data, description: e.target.value } }))} />
            </div>
            <div className="adm-perm-grid">
              <div className="adm-perm-grid-header"><span>Yetki</span><span>Durum</span></div>
              {Object.entries(modal.data.platformPermissions || {}).map(([key, val]) => (
                <div className="adm-perm-grid-row" key={key}>
                  <span className="adm-perm-grid-module">{PERM_LABELS[key] || key}</span>
                  <label className="adm-perm-check">
                    <input type="checkbox" checked={!!val} onChange={() => setModal(m => ({
                      ...m, data: { ...m.data, platformPermissions: { ...m.data.platformPermissions, [key]: !val } }
                    }))} />
                    <span className="adm-perm-check-box" />
                    <span>{val ? 'Açık' : 'Kapalı'}</span>
                  </label>
                </div>
              ))}
            </div>
            <div className="adm-modal-actions">
              <button className="adm-btn" onClick={() => setModal(null)}>İptal</button>
              <button className="adm-btn primary" onClick={async () => {
                const d = modal.data;
                if (!d.code || !d.name) return;
                if (modal.editing) {
                  const res = await apiFetch(`/system-roles/${d.id}`, { method: 'PUT', body: JSON.stringify({ name: d.name, description: d.description, platformPermissions: d.platformPermissions }) });
                  if (res && !res._error) setSystemRoles(prev => prev.map(x => x.id === d.id ? { ...x, ...d } : x));
                } else {
                  const res = await apiFetch('/system-roles', { method: 'POST', body: JSON.stringify(d) });
                  if (res && !res._error) setSystemRoles(prev => [...prev, { ...res.role, userCount: 0 }]);
                }
                setModal(null);
              }}>{modal.editing ? 'Güncelle' : 'Oluştur'}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );

  /* ═══════════════════════════════════════════════
     RENDER — Simple tables (Projects, Forum, Posts, Jobs, Contacts)
     ═══════════════════════════════════════════════ */
  const renderProjects = () => (
    <div className="adm-table-wrap">
      <table className="adm-table">
        <thead><tr><th>Proje Adı</th><th>Sahip</th><th>Paylaşım</th><th>Durum</th><th>Tarih</th><th>İşlem</th></tr></thead>
        <tbody>
          {projects.map(p => (
            <tr key={p.id}>
              <td>{p.name || p.title || p.id}</td>
              <td>{p.ownerName}</td>
              <td><span className="adm-badge blue">{p.shareCount}</span></td>
              <td><span className="adm-badge">{p.status || 'Aktif'}</span></td>
              <td>{formatDate(p.createdAt)}</td>
              <td><button className="adm-btn-sm danger" onClick={() => handleDelete('projects', p.id, setProjects)} title="Sil"><SvgIcon name="trash" size={14} /></button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {projects.length === 0 && <div className="adm-empty">Henüz proje yok.</div>}
    </div>
  );

  const renderForum = () => (
    <div className="adm-table-wrap">
      <table className="adm-table">
        <thead><tr><th>Konu</th><th>Yazar</th><th>Yanıt</th><th>Tarih</th><th>İşlem</th></tr></thead>
        <tbody>
          {threads.map(t => (
            <tr key={t.id}>
              <td>{t.title}</td>
              <td>{t.authorName}</td>
              <td>{t.replyCount}</td>
              <td>{formatDate(t.createdAt)}</td>
              <td><button className="adm-btn-sm danger" onClick={() => handleDelete('forum', t.id, setThreads)} title="Sil"><SvgIcon name="trash" size={14} /></button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {threads.length === 0 && <div className="adm-empty">Henüz forum konusu yok.</div>}
    </div>
  );

  const renderPosts = () => (
    <div className="adm-table-wrap">
      <table className="adm-table">
        <thead><tr><th>İçerik</th><th>Yazar</th><th>Beğeni</th><th>Yorum</th><th>Tarih</th><th>İşlem</th></tr></thead>
        <tbody>
          {posts.map(p => (
            <tr key={p.id}>
              <td className="adm-td-text">{p.text || p.content || '—'}</td>
              <td>{p.authorName}</td>
              <td>{p.likeCount}</td>
              <td>{p.commentCount}</td>
              <td>{formatDate(p.createdAt)}</td>
              <td><button className="adm-btn-sm danger" onClick={() => handleDelete('posts', p.id, setPosts)} title="Sil"><SvgIcon name="trash" size={14} /></button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {posts.length === 0 && <div className="adm-empty">Henüz paylaşım yok.</div>}
    </div>
  );

  const renderJobs = () => (
    <div className="adm-table-wrap">
      <table className="adm-table">
        <thead><tr><th>İlan</th><th>Yayınlayan</th><th>Başvuru</th><th>Durum</th><th>Tarih</th><th>İşlem</th></tr></thead>
        <tbody>
          {jobs.map(j => (
            <tr key={j.id}>
              <td>{j.title}</td>
              <td>{j.authorName}</td>
              <td>{j.applicationCount}</td>
              <td>
                <select className="adm-select-sm" value={j.status || 'active'} onChange={async e => {
                  await apiFetch(`/jobs/${j.id}`, { method: 'PUT', body: JSON.stringify({ status: e.target.value }) });
                  setJobs(prev => prev.map(x => x.id === j.id ? { ...x, status: e.target.value } : x));
                }}>
                  <option value="active">Aktif</option>
                  <option value="closed">Kapalı</option>
                  <option value="suspended">Askıda</option>
                </select>
              </td>
              <td>{formatDate(j.createdAt)}</td>
              <td><button className="adm-btn-sm danger" onClick={() => handleDelete('jobs', j.id, setJobs)} title="Sil"><SvgIcon name="trash" size={14} /></button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {jobs.length === 0 && <div className="adm-empty">Henüz iş ilanı yok.</div>}
    </div>
  );

  const renderContacts = () => (
    <div className="adm-table-wrap">
      <table className="adm-table">
        <thead><tr><th>Ad</th><th>E-posta</th><th>Mesaj</th><th>Tarih</th><th>İşlem</th></tr></thead>
        <tbody>
          {contacts.map(c => (
            <tr key={c.id}>
              <td>{c.name || c.firstName || '—'}</td>
              <td>{c.email}</td>
              <td className="adm-td-text">{c.message || c.text || '—'}</td>
              <td>{formatDate(c.createdAt)}</td>
              <td><button className="adm-btn-sm danger" onClick={() => handleDelete('contacts', c.id, setContacts)} title="Sil"><SvgIcon name="trash" size={14} /></button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {contacts.length === 0 && <div className="adm-empty">Henüz iletişim mesajı yok.</div>}
    </div>
  );

  /* ═══════════════════════════════════════════════
     RENDER — Pricing (Fiyatlandırma)
     ═══════════════════════════════════════════════ */

  const VOLTAGE_COLORS = { AG: '#22c55e', OG: '#f59e0b', YG: '#ef4444', ZA: '#8b5cf6' };
  const STATUS_LABELS = { draft: 'Taslak', published: 'Yayında', archived: 'Arşiv' };
  const STATUS_COLORS = { draft: 'var(--adm-muted)', published: 'var(--adm-green)', archived: 'var(--adm-accent2)' };

  const handlePricingTierSave = async () => {
    if (!modal?.data) return;
    const d = modal.data;
    if (modal.editing) {
      const res = await apiFetch(`/membership-tiers/${d.id}`, { method: 'PUT', body: JSON.stringify(d) });
      if (res && !res._error) {
        setMembershipTiers(prev => prev.map(t => t.id === d.id ? { ...t, ...res.tier } : t));
        setModal(null);
      } else { alert(res?.message || 'Güncelleme başarısız.'); }
    } else {
      const res = await apiFetch('/membership-tiers', { method: 'POST', body: JSON.stringify(d) });
      if (res && !res._error) {
        setMembershipTiers(prev => [...prev, res.tier]);
        setModal(null);
      } else { alert(res?.message || 'Oluşturma başarısız.'); }
    }
  };

  const handlePricingEditorSave = async () => {
    if (!modal?.data) return;
    const d = modal.data;
    if (modal.editing) {
      const res = await apiFetch(`/pricing-editors/${d.id}`, { method: 'PUT', body: JSON.stringify(d) });
      if (res && !res._error) {
        setPricingEditors(prev => prev.map(e => e.id === d.id ? { ...e, ...res.editor } : e));
        setModal(null);
      } else { alert(res?.message || 'Güncelleme başarısız.'); }
    } else {
      const res = await apiFetch('/pricing-editors', { method: 'POST', body: JSON.stringify(d) });
      if (res && !res._error) {
        setPricingEditors(prev => [...prev, res.editor]);
        setModal(null);
      } else { alert(res?.message || 'Oluşturma başarısız.'); }
    }
  };

  const handleTierAction = async (id, action) => {
    const res = await apiFetch(`/membership-tiers/${id}/${action}`, { method: 'POST' });
    if (res && !res._error) {
      // Reload all tiers
      const t = await apiFetch('/membership-tiers');
      if (t && !t._error) setMembershipTiers(t.tiers);
    } else { alert(res?.message || 'İşlem başarısız.'); }
  };

  const handleEditorAction = async (id, action) => {
    const res = await apiFetch(`/pricing-editors/${id}/${action}`, { method: 'POST' });
    if (res && !res._error) {
      const e = await apiFetch('/pricing-editors');
      if (e && !e._error) setPricingEditors(e.editors);
      if (action === 'archive') {
        const t = await apiFetch('/membership-tiers');
        if (t && !t._error) setMembershipTiers(t.tiers);
      }
    } else { alert(res?.message || 'İşlem başarısız.'); }
  };

  // ─── Yasal Metinler — KVKK ispat yükümlülüğü ───
  const CONSENT_LABELS = {
    tos: 'Üyelik Sözleşmesi',
    kvkk: 'KVKK Aydınlatma',
    cerez: 'Çerez Politikası',
    riza: 'Açık Rıza Metni',
    beta: 'Beta Şartları',
    marketing_email: 'Pazarlama (e-posta/SMS)',
    profile_visibility: 'Profil Görünürlüğü',
    testimonial_use: 'Yorum Pazarlama Kullanımı',
    testimonial_publish: 'Anasayfa Yorum Yayını',
    ai_training: 'AI Eğitimi',
    cross_border: 'Yurt Dışına Veri Aktarımı',
  };

  const fetchAuditLogs = async () => {
    setAuditLoading(true);
    try {
      const params = new URLSearchParams();
      if (auditFilter.category) params.set('category', auditFilter.category);
      if (auditFilter.q) params.set('q', auditFilter.q);
      if (auditFilter.from) params.set('from', auditFilter.from);
      if (auditFilter.to) params.set('to', auditFilter.to);
      params.set('limit', '200');
      const d = await apiFetch(`/audit-logs?${params.toString()}`);
      if (d && !d._error) {
        setAuditLogs(d.logs || []);
        setAuditTotal(d.total || 0);
      }
    } finally { setAuditLoading(false); }
  };

  const verifyChainIntegrity = async () => {
    const r = await apiFetch('/audit-logs/integrity');
    if (r && !r._error) setAuditIntegrity(r);
  };

  const CATEGORY_LABELS = {
    access: 'Erişim',
    content: 'İçerik',
    auth: 'Kimlik Doğrulama',
    kvkk_access: 'KVKK Erişim',
    domain_event: 'İş Olayı',
    system: 'Sistem',
  };

  // ─── Menü & Anasayfa Navigation Editor ────────────────────────
  const updateNavList = (path, list) => {
    setNavConfig(prev => {
      if (path === 'homeShortcuts') return { ...prev, homeShortcuts: list };
      return { ...prev, topbarMenus: { ...prev.topbarMenus, [path]: list } };
    });
  };
  const navItemChange = (path, idx, field, value) => {
    setNavConfig(prev => {
      const list = path === 'homeShortcuts' ? prev.homeShortcuts : prev.topbarMenus[path];
      const next = list.map((it, i) => i === idx ? { ...it, [field]: value } : it);
      return path === 'homeShortcuts'
        ? { ...prev, homeShortcuts: next }
        : { ...prev, topbarMenus: { ...prev.topbarMenus, [path]: next } };
    });
  };
  const navItemAdd = (path) => {
    setNavConfig(prev => {
      const list = path === 'homeShortcuts' ? prev.homeShortcuts : prev.topbarMenus[path];
      const next = [...list, { label: '', path: '' }];
      return path === 'homeShortcuts'
        ? { ...prev, homeShortcuts: next }
        : { ...prev, topbarMenus: { ...prev.topbarMenus, [path]: next } };
    });
  };
  const navItemRemove = (path, idx) => {
    setNavConfig(prev => {
      const list = path === 'homeShortcuts' ? prev.homeShortcuts : prev.topbarMenus[path];
      const next = list.filter((_, i) => i !== idx);
      return path === 'homeShortcuts'
        ? { ...prev, homeShortcuts: next }
        : { ...prev, topbarMenus: { ...prev.topbarMenus, [path]: next } };
    });
  };
  const navItemMove = (path, idx, dir) => {
    setNavConfig(prev => {
      const list = path === 'homeShortcuts' ? prev.homeShortcuts : prev.topbarMenus[path];
      const swapIdx = idx + dir;
      if (swapIdx < 0 || swapIdx >= list.length) return prev;
      const next = [...list];
      [next[idx], next[swapIdx]] = [next[swapIdx], next[idx]];
      return path === 'homeShortcuts'
        ? { ...prev, homeShortcuts: next }
        : { ...prev, topbarMenus: { ...prev.topbarMenus, [path]: next } };
    });
  };
  const saveNavigation = async () => {
    setNavSaving(true);
    try {
      const tk = localStorage.getItem('projabze_token');
      const res = await fetch(`${API_URL}/api/system-settings/navigation`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tk}` },
        body: JSON.stringify(navConfig),
      });
      if (res.ok) {
        const d = await res.json();
        if (d.navigation) setNavConfig(d.navigation);
        setNavSavedAt(Date.now());
      }
    } catch (e) { console.error('Nav save error:', e); }
    setNavSaving(false);
  };

  const NavListEditor = ({ pathKey, title, hint }) => {
    const list = pathKey === 'homeShortcuts' ? navConfig.homeShortcuts : navConfig.topbarMenus[pathKey] || [];
    return (
      <div className="adm-card" style={{ marginBottom: 16 }}>
        <div className="adm-card-header">
          <div>
            <h3 style={{ margin: 0 }}>{title}</h3>
            {hint && <p style={{ margin: '4px 0 0', fontSize: 12, color: 'var(--muted)' }}>{hint}</p>}
          </div>
          <button className="btn btn-ghost" onClick={() => navItemAdd(pathKey)}>+ Öğe Ekle</button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 12 }}>
          {list.length === 0 ? (
            <p style={{ fontSize: 12, color: 'var(--muted)', margin: 0 }}>Henüz öğe yok.</p>
          ) : list.map((it, i) => (
            <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto auto auto', gap: 8, alignItems: 'center' }}>
              <input
                type="text" placeholder="Etiket"
                value={it.label || ''}
                onChange={e => navItemChange(pathKey, i, 'label', e.target.value)}
                style={{ padding: '6px 8px', border: '1px solid var(--border)', borderRadius: 4 }}
              />
              <input
                type="text" placeholder="/yol"
                value={it.path || ''}
                onChange={e => navItemChange(pathKey, i, 'path', e.target.value)}
                style={{ padding: '6px 8px', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'monospace', fontSize: 12 }}
              />
              <button className="btn btn-icon" title="Yukarı taşı" disabled={i === 0} onClick={() => navItemMove(pathKey, i, -1)}>↑</button>
              <button className="btn btn-icon" title="Aşağı taşı" disabled={i === list.length - 1} onClick={() => navItemMove(pathKey, i, 1)}>↓</button>
              <button className="btn btn-icon btn-danger" title="Sil" onClick={() => navItemRemove(pathKey, i)}>×</button>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderNavigation = () => {
    return (
      <div>
        <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 16 }}>
          Topbar'daki Haberler, Sorular ve Daha Fazlası dropdown'larını ve Anasayfa'daki "Hızlı Erişim" şeridini buradan yönet. Etiket: gösterilecek metin. Yol: navigasyon yolu (örn. <code>/news</code>, <code>/jobs</code>).
        </p>

        <NavListEditor
          pathKey="homeShortcuts"
          title="Anasayfa — Hızlı Erişim Şeridi"
          hint="Anasayfanın üstündeki kısa yol çipleri."
        />
        <NavListEditor
          pathKey="haberler"
          title="Topbar — Haberler Menüsü"
          hint="Haberler sekmesine tıklandığında açılan dropdown öğeleri."
        />
        <NavListEditor
          pathKey="sorular"
          title="Topbar — Sorular Menüsü"
          hint="Sorular sekmesine tıklandığında açılan dropdown öğeleri."
        />
        <NavListEditor
          pathKey="daha_fazlasi"
          title="Topbar — Daha Fazlası Menüsü"
          hint="Daha Fazlası sekmesine tıklandığında açılan dropdown öğeleri."
        />

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 16 }}>
          <button className="btn btn-primary" onClick={saveNavigation} disabled={navSaving}>
            {navSaving ? 'Kaydediliyor…' : 'Kaydet'}
          </button>
          {navSavedAt && (
            <span style={{ fontSize: 12, color: '#22c55e' }}>
              ✓ Kaydedildi · {new Date(navSavedAt).toLocaleTimeString('tr-TR')}
            </span>
          )}
        </div>
      </div>
    );
  };

  const renderLegal = () => {
    return (
      <div>
        <div className="adm-disc-tabs" style={{ marginBottom: 16 }}>
          <button className={`adm-disc-tab ${legalSubTab === 'texts' ? 'active' : ''}`} onClick={() => setLegalSubTab('texts')}>
            Yasal Metinler
          </button>
          <button className={`adm-disc-tab ${legalSubTab === 'flow' ? 'active' : ''}`} onClick={() => setLegalSubTab('flow')}>
            Kayıt Akışı Önizleme
          </button>
          <button className={`adm-disc-tab ${legalSubTab === 'log' ? 'active' : ''}`} onClick={() => setLegalSubTab('log')}>
            Onay Kayıtları ({legalAcceptances.length})
          </button>
          <button
            className={`adm-disc-tab ${legalSubTab === 'audit' ? 'active' : ''}`}
            onClick={() => { setLegalSubTab('audit'); if (auditLogs.length === 0) fetchAuditLogs(); }}
          >
            Erişim Logları{auditSummary ? ` (${auditSummary.total})` : ''}
          </button>
        </div>

        {legalSubTab === 'texts' && (
          <div>
            <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 12 }}>
              Sürüm: <strong>v1.0-draft</strong> · Hukuki onay durumu: <strong style={{ color: '#eab308' }}>Beklemede</strong>
            </p>
            <iframe
              src="/privacy"
              title="Yasal Metinler"
              style={{
                width: '100%',
                height: '80vh',
                border: '1px solid var(--border)',
                borderRadius: 6,
                background: '#fff',
              }}
            />
            <p style={{ fontSize: 12, color: 'var(--muted)', marginTop: 8 }}>
              Bu iframe kullanıcıya gösterilen <a href="/privacy" target="_blank" rel="noopener noreferrer">/privacy</a> sayfasının canlı önizlemesidir.
            </p>
          </div>
        )}

        {legalSubTab === 'flow' && (
          <div>
            <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 16 }}>
              Yeni kullanıcı kayıt olurken aşağıdaki onay akışıyla karşılaşır. Açık rıza checkboxları varsayılan olarak kapalıdır (opt-in).
            </p>
            <div style={{
              maxWidth: 540,
              padding: '1.25rem',
              background: 'var(--surface, #f5f5f5)',
              border: '1px solid var(--border)',
              borderRadius: 8,
              fontSize: 13,
            }}>
              <h3 style={{ marginTop: 0, marginBottom: 12, fontSize: 16 }}>Hesap Oluştur</h3>
              <div style={{ marginBottom: 16, padding: '8px 12px', background: 'var(--bg, #fff)', border: '1px solid var(--border)', borderRadius: 4, color: 'var(--muted)' }}>
                Ad / Soyad / E-posta / Şifre alanları (mockup)
              </div>
              <div style={{
                padding: '.85rem',
                background: 'rgba(167, 82, 175, .04)',
                border: '1px solid var(--border)',
                borderRadius: 6,
              }}>
                <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 12, padding: '8px 10px', background: 'rgba(234, 179, 8, .1)', borderLeft: '3px solid #eab308', borderRadius: '0 4px 4px 0', marginBottom: 8, cursor: 'default' }}>
                  <input type="checkbox" disabled checked style={{ marginTop: 2 }} />
                  <span>
                    <strong>(Zorunlu)</strong>{' '}
                    <span style={{ color: 'var(--accent)', textDecoration: 'underline' }}>Üyelik Sözleşmesi</span>'ni ve{' '}
                    <span style={{ color: 'var(--accent)', textDecoration: 'underline' }}>KVKK Aydınlatma Metni</span>'ni okudum, kabul ediyorum.
                  </span>
                </label>
                <div style={{ paddingTop: 8, borderTop: '1px dashed var(--border)' }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: 'var(--muted)', textTransform: 'uppercase', marginBottom: 6 }}>
                    Açık Rıza (Opsiyonel)
                  </div>
                  {[
                    'Yeni özellikler ve kampanyalar hakkında e-posta/SMS bildirim almak istiyorum.',
                    'Profil bilgilerimin diğer kullanıcılara görünür kılınmasını kabul ediyorum.',
                    'İleride yazacağım olumlu yorumların pazarlama materyallerinde ad/rol bilgimle yayınlanmasını kabul ediyorum.',
                  ].map((txt, i) => (
                    <label key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 12, marginBottom: 6, cursor: 'default' }}>
                      <input type="checkbox" disabled style={{ marginTop: 2 }} />
                      <span>{txt}</span>
                    </label>
                  ))}
                </div>
              </div>
              <button disabled style={{ marginTop: 12, padding: '8px 16px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 4, cursor: 'default', opacity: .8 }}>
                Hesap Oluştur (mockup)
              </button>
            </div>
            <ul style={{ marginTop: 16, fontSize: 12, color: 'var(--muted)' }}>
              <li>Zorunlu kutu işaretlenmeden kayıt başarısız olur (backend tarafında da kontrol edilir).</li>
              <li>Her kayıt; userId, IP, UA, sürüm bilgisi ile audit log'a yazılır (Onay Kayıtları sekmesi).</li>
              <li>Opsiyonel rızalar opt-in (varsayılan kapalı) — KVKK md. 5/1'e uygundur.</li>
            </ul>
          </div>
        )}

        {legalSubTab === 'log' && (
          <div className="adm-table-wrap">
            <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 12 }}>
              KVKK ispat yükümlülüğü için her açık rıza/sözleşme kabul/geri çekme kaydı tutulur (userId, IP, UA, sürüm).
            </p>
            <table className="adm-table">
              <thead>
                <tr>
                  <th>Kullanıcı</th>
                  <th>Tip</th>
                  <th>Durum</th>
                  <th>Sürüm</th>
                  <th>Yöntem</th>
                  <th>Tarih</th>
                  <th>IP / UA</th>
                </tr>
              </thead>
              <tbody>
                {legalAcceptances.length === 0 ? (
                  <tr><td colSpan={7} style={{ textAlign: 'center', padding: 24, color: 'var(--muted)' }}>Henüz kayıt yok.</td></tr>
                ) : legalAcceptances.map(a => (
                  <tr key={a.id}>
                    <td>
                      <div style={{ fontWeight: 600 }}>{a.userName || '—'}</div>
                      <div style={{ fontSize: 11, color: 'var(--muted)' }}>{a.userEmail}</div>
                    </td>
                    <td>
                      <div>{CONSENT_LABELS[a.consentType] || a.consentType}</div>
                      {a.required && <span style={{ fontSize: 9, padding: '1px 5px', background: 'rgba(234,179,8,.15)', color: '#eab308', borderRadius: 3, fontWeight: 700 }}>ZORUNLU</span>}
                    </td>
                    <td>
                      {a.granted ? (
                        <span style={{ color: '#22c55e', fontWeight: 600 }}>✓ Kabul</span>
                      ) : a.withdrawn ? (
                        <span style={{ color: '#f97316', fontWeight: 600 }}>↩ Geri çekildi</span>
                      ) : (
                        <span style={{ color: '#888' }}>Reddedildi</span>
                      )}
                    </td>
                    <td style={{ fontSize: 11, fontFamily: 'monospace' }}>{a.documentVersion}</td>
                    <td style={{ fontSize: 11 }}>{a.method}</td>
                    <td style={{ fontSize: 11, color: 'var(--muted)' }}>
                      {a.acceptedAt ? new Date(a.acceptedAt).toLocaleString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : ''}
                    </td>
                    <td style={{ fontSize: 11, color: 'var(--muted)', maxWidth: 220 }}>
                      <div>{a.ipAddress || '—'}</div>
                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={a.userAgent}>{(a.userAgent || '').slice(0, 40)}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {legalSubTab === 'audit' && (
          <div>
            <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 12 }}>
              5651 sayılı Kanun (yer sağlayıcı) ve KVKK md.12 (veri güvenliği) gereği tüm sistem
              olayları hash zinciri ile bağlı şekilde kayıt altına alınır. PII alanlar pseudonimize
              edilir, IP adresi /24 bloğuna maskelenir.
            </p>

            {auditSummary && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 8, marginBottom: 16 }}>
                {[
                  { label: 'Toplam Kayıt', value: auditSummary.total, color: 'var(--accent)' },
                  { label: 'Son 24 saat', value: Object.values(auditSummary.last24h || {}).reduce((a,b)=>a+b,0), color: '#22c55e' },
                  { label: 'Son 7 gün', value: Object.values(auditSummary.last7d || {}).reduce((a,b)=>a+b,0), color: '#3b82f6' },
                  { label: 'Son 30 gün', value: Object.values(auditSummary.last30d || {}).reduce((a,b)=>a+b,0), color: '#a855f7' },
                ].map((c, i) => (
                  <div key={i} style={{ padding: '10px 14px', background: 'var(--surface, #f5f5f5)', border: '1px solid var(--border)', borderRadius: 6 }}>
                    <div style={{ fontSize: 11, color: 'var(--muted)', textTransform: 'uppercase', fontWeight: 600 }}>{c.label}</div>
                    <div style={{ fontSize: 20, fontWeight: 700, color: c.color }}>{c.value}</div>
                  </div>
                ))}
              </div>
            )}

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'flex-end', marginBottom: 12, padding: 12, background: 'var(--surface, #f5f5f5)', border: '1px solid var(--border)', borderRadius: 6 }}>
              <div>
                <label style={{ display: 'block', fontSize: 11, color: 'var(--muted)', marginBottom: 2 }}>Kategori</label>
                <select value={auditFilter.category} onChange={e => setAuditFilter(f => ({ ...f, category: e.target.value }))} style={{ padding: '6px 8px', border: '1px solid var(--border)', borderRadius: 4 }}>
                  <option value="">Hepsi</option>
                  {Object.entries(CATEGORY_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 11, color: 'var(--muted)', marginBottom: 2 }}>Arama (endpoint / action)</label>
                <input type="text" value={auditFilter.q} onChange={e => setAuditFilter(f => ({ ...f, q: e.target.value }))} placeholder="örn. /api/projects" style={{ padding: '6px 8px', border: '1px solid var(--border)', borderRadius: 4, minWidth: 220 }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 11, color: 'var(--muted)', marginBottom: 2 }}>Başlangıç</label>
                <input type="date" value={auditFilter.from} onChange={e => setAuditFilter(f => ({ ...f, from: e.target.value }))} style={{ padding: '6px 8px', border: '1px solid var(--border)', borderRadius: 4 }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 11, color: 'var(--muted)', marginBottom: 2 }}>Bitiş</label>
                <input type="date" value={auditFilter.to} onChange={e => setAuditFilter(f => ({ ...f, to: e.target.value }))} style={{ padding: '6px 8px', border: '1px solid var(--border)', borderRadius: 4 }} />
              </div>
              <button className="btn btn-primary" onClick={fetchAuditLogs} disabled={auditLoading}>
                {auditLoading ? 'Yükleniyor…' : 'Filtrele'}
              </button>
              <button className="btn btn-ghost" onClick={verifyChainIntegrity}>
                Bütünlüğü Doğrula
              </button>
            </div>

            {auditIntegrity && (
              <div style={{ padding: 10, marginBottom: 12, background: auditIntegrity.ok ? 'rgba(34,197,94,.08)' : 'rgba(239,68,68,.08)', border: `1px solid ${auditIntegrity.ok ? '#22c55e' : '#ef4444'}`, borderRadius: 4, fontSize: 12 }}>
                {auditIntegrity.ok ? (
                  <span style={{ color: '#22c55e', fontWeight: 600 }}>✓ Hash zinciri tutarlı — toplam {auditIntegrity.total} kayıt doğrulandı.</span>
                ) : (
                  <span style={{ color: '#ef4444', fontWeight: 600 }}>✗ Hash zinciri kırık — {auditIntegrity.errors.length} kayıtta tutarsızlık.</span>
                )}
              </div>
            )}

            <div className="adm-table-wrap">
              <table className="adm-table">
                <thead>
                  <tr>
                    <th>Zaman</th>
                    <th>Kategori</th>
                    <th>Aktör</th>
                    <th>Eylem</th>
                    <th>Endpoint</th>
                    <th>Durum</th>
                    <th>IP</th>
                  </tr>
                </thead>
                <tbody>
                  {auditLogs.length === 0 ? (
                    <tr><td colSpan={7} style={{ textAlign: 'center', padding: 24, color: 'var(--muted)' }}>{auditLoading ? 'Yükleniyor…' : 'Kayıt yok.'}</td></tr>
                  ) : auditLogs.map(l => (
                    <tr key={l.id}>
                      <td style={{ fontSize: 11, color: 'var(--muted)', whiteSpace: 'nowrap' }}>
                        {new Date(l.occurredAt).toLocaleString('tr-TR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                      </td>
                      <td>
                        <span style={{ fontSize: 10, padding: '2px 6px', background: 'rgba(167,82,175,.1)', color: 'var(--accent)', borderRadius: 3, fontWeight: 600 }}>
                          {CATEGORY_LABELS[l.category] || l.category}
                        </span>
                      </td>
                      <td style={{ fontSize: 12 }}>
                        {l.actorName ? (
                          <>
                            <div style={{ fontWeight: 600 }}>{l.actorName}</div>
                            <div style={{ fontSize: 10, color: 'var(--muted)' }}>{l.actorEmail}</div>
                          </>
                        ) : (
                          <span style={{ color: 'var(--muted)' }}>{l.actorType === 'anonymous' ? 'Anonim' : (l.actorType || '—')}</span>
                        )}
                      </td>
                      <td style={{ fontSize: 11, fontFamily: 'monospace', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={l.action}>
                        {l.action || '—'}
                      </td>
                      <td style={{ fontSize: 11, fontFamily: 'monospace', maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={l.endpoint}>
                        {l.httpMethod} {l.endpoint}
                      </td>
                      <td>
                        {l.httpStatus && (
                          <span style={{
                            fontSize: 11, fontWeight: 600,
                            color: l.httpStatus < 300 ? '#22c55e' : l.httpStatus < 400 ? '#3b82f6' : l.httpStatus < 500 ? '#eab308' : '#ef4444',
                          }}>{l.httpStatus}</span>
                        )}
                      </td>
                      <td style={{ fontSize: 11, color: 'var(--muted)', fontFamily: 'monospace' }}>{l.ipAddressMasked || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {auditTotal > auditLogs.length && (
                <p style={{ fontSize: 11, color: 'var(--muted)', textAlign: 'center', marginTop: 8 }}>
                  {auditLogs.length} / {auditTotal} gösteriliyor — filtreyi daraltın.
                </p>
              )}
            </div>

            <div style={{ marginTop: 16, padding: 10, fontSize: 11, color: 'var(--muted)', background: 'rgba(59,130,246,.05)', borderLeft: '3px solid #3b82f6', borderRadius: '0 4px 4px 0' }}>
              <strong>Saklama politikası:</strong> "Erişim" kategorisi 90 gün sonra IP/UA anonimleştirilir,
              2 yıl sonra silinir. "Auth", "İçerik", "KVKK Erişim" ve "İş Olayı" kayıtları VUK/TTK
              gereği 10 yıla kadar saklanır.
            </div>
          </div>
        )}
      </div>
    );
  };

  // ─── Testimonials moderation ───
  const updateTestimonialStatus = async (id, status) => {
    try {
      const tk = localStorage.getItem('projabze_token');
      const r = await fetch(`${API_URL}/api/testimonials/admin/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tk}` },
        body: JSON.stringify({ status }),
      });
      if (r.ok) {
        setTestimonials(prev => prev.map(t => t.id === id ? { ...t, status } : t));
      }
    } catch (e) { /* ignore */ }
  };

  const renderTestimonials = () => {
    const statusBadge = (status) => {
      const map = {
        pending:  { bg: 'rgba(234,179,8,.18)',  fg: '#eab308', txt: 'BEKLİYOR' },
        approved: { bg: 'rgba(34,197,94,.18)',  fg: '#22c55e', txt: 'YAYINDA' },
        rejected: { bg: 'rgba(239,68,68,.18)',  fg: '#ef4444', txt: 'REDDEDİLDİ' },
      };
      const c = map[status] || map.pending;
      return (
        <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 10, fontWeight: 700, background: c.bg, color: c.fg }}>
          {c.txt}
        </span>
      );
    };
    return (
      <div className="adm-table-wrap">
        <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 12 }}>
          Anasayfada yayınlanmadan önce moderasyon — yalnızca onaylı + açık rızalı yorumlar landing'de görünür.
        </p>
        <table className="adm-table">
          <thead>
            <tr>
              <th>Kullanıcı</th>
              <th>Puan</th>
              <th>Yorum</th>
              <th>Durum</th>
              <th>Rıza</th>
              <th>Tarih</th>
              <th>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {testimonials.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 24, color: 'var(--muted)' }}>Henüz yorum yok.</td></tr>
            ) : testimonials.map(t => (
              <tr key={t.id}>
                <td>
                  <div style={{ fontWeight: 600 }}>{t.authorName}</div>
                  {(t.authorRole || t.authorCity) && (
                    <div style={{ fontSize: 11, color: 'var(--muted)' }}>
                      {[t.authorRole, t.authorCity].filter(Boolean).join(' • ')}
                    </div>
                  )}
                </td>
                <td>{'★'.repeat(t.stars)}{'☆'.repeat(5 - t.stars)}</td>
                <td style={{ maxWidth: 360, fontSize: 13 }}>{t.text}</td>
                <td>{statusBadge(t.status)}</td>
                <td style={{ fontSize: 11, color: 'var(--muted)' }}>
                  {t.publishConsent ? '✓ Açık rıza' : '—'}
                  {t.consentAt && <div>{new Date(t.consentAt).toLocaleDateString('tr-TR')}</div>}
                </td>
                <td style={{ fontSize: 11, color: 'var(--muted)' }}>
                  {t.createdAt ? new Date(t.createdAt).toLocaleString('tr-TR', { day: '2-digit', month: 'short', year: '2-digit' }) : ''}
                </td>
                <td>
                  <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                    {t.status !== 'approved' && (
                      <button className="adm-btn adm-btn-sm" style={{ background: '#22c55e', color: '#fff', border: 'none' }} onClick={() => updateTestimonialStatus(t.id, 'approved')}>
                        Onayla
                      </button>
                    )}
                    {t.status !== 'rejected' && (
                      <button className="adm-btn adm-btn-sm" style={{ background: '#ef4444', color: '#fff', border: 'none' }} onClick={() => updateTestimonialStatus(t.id, 'rejected')}>
                        Reddet
                      </button>
                    )}
                    {t.status !== 'pending' && (
                      <button className="adm-btn adm-btn-sm" onClick={() => updateTestimonialStatus(t.id, 'pending')}>
                        Beklemeye Al
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const renderPricing = () => {
    const pricingTabs = [
      { id: 'tiers', label: 'Üyelik Tipleri' },
      { id: 'editors', label: 'Editörler' },
      { id: 'simulator', label: 'Fiyat Simülatörü' }
    ];

    const filteredTiers = membershipTiers.filter(t => pricingStatusFilter === 'all' || t.status === pricingStatusFilter);
    const filteredEditors = pricingEditors.filter(e => {
      if (pricingStatusFilter !== 'all' && e.status !== pricingStatusFilter) return false;
      if (pricingVoltageFilter !== 'all' && e.voltageLevel !== pricingVoltageFilter) return false;
      return true;
    });

    // Published items for simulator
    const pubTiers = membershipTiers.filter(t => t.status === 'published');
    const pubEditors = pricingEditors.filter(e => e.status === 'published');

    return (
      <div className="adm-pricing">
        {/* Sub-tabs */}
        <div className="adm-disc-tabs" style={{ marginBottom: '1.2rem' }}>
          {pricingTabs.map(t => (
            <button key={t.id} className={`adm-disc-tab ${pricingTab === t.id ? 'active' : ''}`} onClick={() => setPricingTab(t.id)}>{t.label}</button>
          ))}
        </div>

        {/* ──── Üyelik Tipleri Tab ──── */}
        {pricingTab === 'tiers' && (
          <div>
            <div className="adm-toolbar">
              <select value={pricingStatusFilter} onChange={e => setPricingStatusFilter(e.target.value)} className="adm-select">
                <option value="all">Tüm Durumlar</option>
                <option value="draft">Taslak</option>
                <option value="published">Yayında</option>
                <option value="archived">Arşiv</option>
              </select>
              <button className="adm-btn primary" onClick={() => setModal({ type: 'pricing-tier', data: { name: '', slug: '', monthlyPrice: 0, editorDiscountPct: 0, includedEditorIds: [], maxSeats: 1, features: [] } })}>
                <SvgIcon name="plus" size={14} /> Yeni Üyelik Tipi
              </button>
            </div>
            <table className="adm-table">
              <thead>
                <tr>
                  <th>Durum</th><th>Ad</th><th>Aylık Fiyat</th><th>İndirim</th><th>Dahil Editörler</th><th>Koltuk</th><th>Eylemler</th>
                </tr>
              </thead>
              <tbody>
                {filteredTiers.map(t => (
                  <tr key={t.id}>
                    <td><span className="adm-pricing-badge" style={{ background: STATUS_COLORS[t.status] }}>{STATUS_LABELS[t.status]}</span></td>
                    <td><strong>{t.name}</strong></td>
                    <td>{t.monthlyPrice === 0 ? 'Ücretsiz' : `₺${t.monthlyPrice}`}</td>
                    <td>%{Math.round(t.editorDiscountPct * 100)}</td>
                    <td>
                      <div className="adm-pricing-pills">
                        {(t.includedEditorNames || []).map((n, i) => <span key={i} className="adm-pricing-pill">{n}</span>)}
                        {(!t.includedEditorNames || t.includedEditorNames.length === 0) && <span className="adm-muted-text">—</span>}
                      </div>
                    </td>
                    <td>{t.maxSeats}</td>
                    <td>
                      <div className="adm-pricing-actions">
                        {t.status === 'draft' && <>
                          <button className="adm-btn-sm" onClick={() => setModal({ type: 'pricing-tier', data: { ...t }, editing: true })}>Düzenle</button>
                          <button className="adm-btn-sm green" onClick={() => handleTierAction(t.id, 'publish')}>Yayınla</button>
                          <button className="adm-btn-sm red" onClick={() => handleDelete('membership-tiers', t.id, setMembershipTiers)}>Sil</button>
                        </>}
                        {t.status === 'published' && <>
                          <button className="adm-btn-sm" onClick={() => handleTierAction(t.id, 'clone')}>Klonla</button>
                          <button className="adm-btn-sm orange" onClick={() => handleTierAction(t.id, 'archive')}>Arşivle</button>
                        </>}
                        {t.status === 'archived' && <>
                          <button className="adm-btn-sm" onClick={() => handleTierAction(t.id, 'clone')}>Klonla</button>
                          <button className="adm-btn-sm red" onClick={() => handleDelete('membership-tiers', t.id, setMembershipTiers)}>Sil</button>
                        </>}
                      </div>
                    </td>
                  </tr>
                ))}
                {filteredTiers.length === 0 && <tr><td colSpan={7} className="adm-empty">Üyelik tipi bulunamadı.</td></tr>}
              </tbody>
            </table>
          </div>
        )}

        {/* ──── Editörler Tab ──── */}
        {pricingTab === 'editors' && (
          <div>
            <div className="adm-toolbar">
              <select value={pricingStatusFilter} onChange={e => setPricingStatusFilter(e.target.value)} className="adm-select">
                <option value="all">Tüm Durumlar</option>
                <option value="draft">Taslak</option>
                <option value="published">Yayında</option>
                <option value="archived">Arşiv</option>
              </select>
              <select value={pricingVoltageFilter} onChange={e => setPricingVoltageFilter(e.target.value)} className="adm-select">
                <option value="all">Tüm Gerilimler</option>
                <option value="AG">AG</option>
                <option value="OG">OG</option>
                <option value="YG">YG</option>
                <option value="ZA">ZA</option>
              </select>
              <button className="adm-btn primary" onClick={() => setModal({ type: 'pricing-editor', data: { name: '', slug: '', description: '', voltageLevel: 'AG', listPrice: 0, tools: [] } })}>
                <SvgIcon name="plus" size={14} /> Yeni Editör
              </button>
            </div>
            <table className="adm-table">
              <thead>
                <tr>
                  <th>Durum</th><th>Ad</th><th>Gerilim</th><th>Fiyat (₺/ay)</th><th>Dahil Olduğu Planlar</th><th>Eylemler</th>
                </tr>
              </thead>
              <tbody>
                {filteredEditors.map(e => (
                  <tr key={e.id}>
                    <td><span className="adm-pricing-badge" style={{ background: STATUS_COLORS[e.status] }}>{STATUS_LABELS[e.status]}</span></td>
                    <td><strong>{e.name}</strong><br /><span className="adm-muted-text">{e.slug}</span></td>
                    <td><span className="adm-pricing-badge" style={{ background: VOLTAGE_COLORS[e.voltageLevel] }}>{e.voltageLevel}</span></td>
                    <td>₺{e.listPrice}</td>
                    <td>
                      <div className="adm-pricing-pills">
                        {(e.includedInTiers || []).map((n, i) => <span key={i} className="adm-pricing-pill">{n}</span>)}
                        {(!e.includedInTiers || e.includedInTiers.length === 0) && <span className="adm-muted-text">—</span>}
                      </div>
                    </td>
                    <td>
                      <div className="adm-pricing-actions">
                        {e.status === 'draft' && <>
                          <button className="adm-btn-sm" onClick={() => setModal({ type: 'pricing-editor', data: { ...e }, editing: true })}>Düzenle</button>
                          <button className="adm-btn-sm green" onClick={() => handleEditorAction(e.id, 'publish')}>Yayınla</button>
                          <button className="adm-btn-sm red" onClick={() => handleDelete('pricing-editors', e.id, setPricingEditors)}>Sil</button>
                        </>}
                        {e.status === 'published' && <>
                          <button className="adm-btn-sm" onClick={() => handleEditorAction(e.id, 'clone')}>Klonla</button>
                          <button className="adm-btn-sm orange" onClick={() => handleEditorAction(e.id, 'archive')}>Arşivle</button>
                        </>}
                        {e.status === 'archived' && <>
                          <button className="adm-btn-sm" onClick={() => handleEditorAction(e.id, 'clone')}>Klonla</button>
                          <button className="adm-btn-sm red" onClick={() => handleDelete('pricing-editors', e.id, setPricingEditors)}>Sil</button>
                        </>}
                      </div>
                    </td>
                  </tr>
                ))}
                {filteredEditors.length === 0 && <tr><td colSpan={6} className="adm-empty">Editör bulunamadı.</td></tr>}
              </tbody>
            </table>
          </div>
        )}

        {/* ──── Fiyat Simülatörü Tab ──── */}
        {pricingTab === 'simulator' && (
          <div className="adm-sim">
            <div className="adm-sim-three-col">
              {/* Sol: Fiyat Ayarları */}
              <div className="adm-sim-panel adm-sim-prices">
                <h3>Fiyat Ayarları {simDirty && <span className="adm-sim-dirty-badge">Değişiklik var</span>}</h3>

                <div className="adm-sim-price-section">
                  <div className="adm-sim-label">Üyelik Tipleri</div>
                  {pubTiers.map(t => {
                    const price = simTierPrices[t.id] !== undefined ? simTierPrices[t.id] : t.monthlyPrice;
                    const disc = simTierDiscounts[t.id] !== undefined ? simTierDiscounts[t.id] : t.editorDiscountPct;
                    const priceChanged = simTierPrices[t.id] !== undefined && simTierPrices[t.id] !== t.monthlyPrice;
                    const discChanged = simTierDiscounts[t.id] !== undefined && simTierDiscounts[t.id] !== t.editorDiscountPct;
                    return (
                      <div key={t.id} className="adm-sim-price-row">
                        <span className="adm-sim-price-name">{t.name}</span>
                        <div className="adm-sim-price-inputs">
                          <label className="adm-sim-price-input-wrap">
                            <span>₺</span>
                            <input type="number" className={priceChanged ? 'changed' : ''} value={price} onChange={e => {
                              setSimTierPrices(prev => ({ ...prev, [t.id]: Number(e.target.value) }));
                              setSimDirty(true);
                            }} />
                          </label>
                          <label className="adm-sim-price-input-wrap disc">
                            <span>%</span>
                            <input type="number" min="0" max="100" className={discChanged ? 'changed' : ''} value={Math.round(disc * 100)} onChange={e => {
                              setSimTierDiscounts(prev => ({ ...prev, [t.id]: Number(e.target.value) / 100 }));
                              setSimDirty(true);
                            }} />
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="adm-sim-price-section">
                  <div className="adm-sim-label">Editör Fiyatları (₺/ay)</div>
                  {pubEditors.map(e => {
                    const price = simEditorPrices[e.id] !== undefined ? simEditorPrices[e.id] : e.listPrice;
                    const changed = simEditorPrices[e.id] !== undefined && simEditorPrices[e.id] !== e.listPrice;
                    return (
                      <div key={e.id} className="adm-sim-price-row">
                        <span className="adm-sim-price-name">
                          <span className="adm-pricing-badge" style={{ background: VOLTAGE_COLORS[e.voltageLevel], marginRight: 4, fontSize: '.6rem' }}>{e.voltageLevel}</span>
                          {e.name}
                        </span>
                        <label className="adm-sim-price-input-wrap">
                          <span>₺</span>
                          <input type="number" className={changed ? 'changed' : ''} value={price} onChange={ev => {
                            setSimEditorPrices(prev => ({ ...prev, [e.id]: Number(ev.target.value) }));
                            setSimDirty(true);
                          }} />
                        </label>
                      </div>
                    );
                  })}
                </div>

                <div className="adm-sim-price-actions">
                  <button className="adm-btn primary" disabled={!simDirty} onClick={async () => {
                    const tierUpdates = Object.entries(simTierPrices).map(([id, monthlyPrice]) => {
                      const disc = simTierDiscounts[id];
                      return { id, monthlyPrice, ...(disc !== undefined ? { editorDiscountPct: disc } : {}) };
                    });
                    // Also include tier discount-only changes
                    Object.entries(simTierDiscounts).forEach(([id, editorDiscountPct]) => {
                      if (!tierUpdates.find(u => u.id === id)) tierUpdates.push({ id, editorDiscountPct });
                    });
                    const editorUpdates = Object.entries(simEditorPrices).map(([id, listPrice]) => ({ id, listPrice }));
                    const res = await apiFetch('/pricing-simulator/save', { method: 'PUT', body: JSON.stringify({ tierUpdates, editorUpdates }) });
                    if (res && !res._error) {
                      // Reload data
                      const t = await apiFetch('/membership-tiers');
                      if (t && !t._error) setMembershipTiers(t.tiers);
                      const e = await apiFetch('/pricing-editors');
                      if (e && !e._error) setPricingEditors(e.editors);
                      setSimTierPrices({}); setSimTierDiscounts({}); setSimEditorPrices({}); setSimDirty(false);
                    } else { alert(res?.message || 'Kaydetme başarısız.'); }
                  }}>Değişiklikleri Kaydet</button>
                  {simDirty && <button className="adm-btn" onClick={() => { setSimTierPrices({}); setSimTierDiscounts({}); setSimEditorPrices({}); setSimDirty(false); }}>Sıfırla</button>}
                </div>
              </div>

              {/* Orta: Seçimler */}
              <div className="adm-sim-panel">
                <h3>Simülasyon</h3>

                <label className="adm-sim-label">Üyelik Tipi</label>
                <div className="adm-sim-tier-cards">
                  {pubTiers.map(t => {
                    const price = simTierPrices[t.id] !== undefined ? simTierPrices[t.id] : t.monthlyPrice;
                    const disc = simTierDiscounts[t.id] !== undefined ? simTierDiscounts[t.id] : t.editorDiscountPct;
                    return (
                      <div key={t.id} className={`adm-sim-tier-card ${simTierId === t.id ? 'selected' : ''}`} onClick={() => setSimTierId(t.id)}>
                        <div className="adm-sim-tier-name">{t.name}</div>
                        <div className="adm-sim-tier-price">{price === 0 ? 'Ücretsiz' : `₺${price}/ay`}</div>
                        <div className="adm-sim-tier-disc">%{Math.round(disc * 100)} indirim</div>
                      </div>
                    );
                  })}
                </div>

                <label className="adm-sim-label">Editörler</label>
                <div className="adm-sim-editors">
                  {pubEditors.map(e => {
                    const sel = simEditorIds.includes(e.id);
                    const tier = pubTiers.find(t => t.id === simTierId);
                    const included = tier && (tier.includedEditorIds || []).includes(e.id);
                    const price = simEditorPrices[e.id] !== undefined ? simEditorPrices[e.id] : e.listPrice;
                    return (
                      <label key={e.id} className={`adm-sim-editor-row ${sel ? 'selected' : ''} ${included ? 'included' : ''}`}>
                        <input type="checkbox" checked={sel} onChange={() => {
                          setSimEditorIds(prev => sel ? prev.filter(x => x !== e.id) : [...prev, e.id]);
                        }} />
                        <span className="adm-pricing-badge" style={{ background: VOLTAGE_COLORS[e.voltageLevel], marginRight: 6 }}>{e.voltageLevel}</span>
                        <span className="adm-sim-editor-name">{e.name}</span>
                        <span className="adm-sim-editor-price">{included ? <em>Dahil</em> : `₺${price}`}</span>
                      </label>
                    );
                  })}
                </div>

                <label className="adm-sim-label">Abonelik Süresi</label>
                <div className="adm-sim-durations">
                  {durationDiscounts.map(d => (
                    <button key={d.id} className={`adm-sim-dur-btn ${simDuration === d.months ? 'active' : ''}`}
                      onClick={() => setSimDuration(d.months)}>
                      {d.label} {d.extraDiscountPct > 0 && <small>+%{Math.round(d.extraDiscountPct * 100)}</small>}
                    </button>
                  ))}
                </div>

              </div>

              {/* Sağ: Sonuçlar */}
              <div className="adm-sim-panel adm-sim-results">
                <h3>Sonuçlar</h3>
                {!simResult ? (
                  <div className="adm-sim-placeholder">Soldaki parametreleri seçerek başlayın.</div>
                ) : (
                  <>
                    <div className="adm-sim-summary">
                      <div className="adm-sim-summary-row">
                        <span>Üyelik ({simResult.tierName})</span>
                        <span>₺{simResult.membershipMonthly}/ay</span>
                      </div>
                      <div className="adm-sim-divider" />
                      {simResult.editors.map(e => (
                        <div key={e.id} className="adm-sim-summary-row">
                          <span>{e.name} {e.isIncluded && <em className="adm-sim-included-tag">dahil</em>}</span>
                          <span>{e.isIncluded ? <s className="adm-muted-text">₺{e.listPrice}</s> : <>₺{e.finalPrice} <s className="adm-muted-text" style={{ fontSize: '.75rem' }}>₺{e.listPrice}</s></>}</span>
                        </div>
                      ))}
                      <div className="adm-sim-divider" />
                      <div className="adm-sim-summary-row total">
                        <span>Aylık Toplam</span>
                        <span>₺{simResult.monthlyEquivalent}</span>
                      </div>
                      {simResult.durationMonths > 1 && (
                        <div className="adm-sim-summary-row">
                          <span>Peşin ({simResult.durationMonths} ay)</span>
                          <span>₺{simResult.totalPayment}</span>
                        </div>
                      )}
                    </div>

                    <div className="adm-sim-info-cards">
                      <div className="adm-sim-info-card">
                        <div className="adm-sim-info-value">%{Math.round(simResult.effectiveDiscount * 100)}</div>
                        <div className="adm-sim-info-label">Efektif İndirim</div>
                      </div>
                      <div className="adm-sim-info-card">
                        <div className="adm-sim-info-value">%{simResult.savingPct}</div>
                        <div className="adm-sim-info-label">Tasarruf</div>
                      </div>
                      <div className="adm-sim-info-card">
                        <div className="adm-sim-info-value">{simResult.editors.filter(e => e.isIncluded).length}</div>
                        <div className="adm-sim-info-label">Dahil Editör</div>
                      </div>
                    </div>

                    {simResult.editors.length === 0 && simTierId && (
                      <div className="adm-sim-warning">Editör seçilmedi. Üyelik alan ama editör seçmeyen kullanıcı platformu kullanamaz!</div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ──── Modals ──── */}
        {modal?.type === 'pricing-tier' && (
          <div className="adm-modal-backdrop" onClick={() => setModal(null)}>
            <div className="adm-modal" style={{ maxWidth: 520 }} onClick={e => e.stopPropagation()}>
              <div className="adm-modal-header">
                <h2>{modal.editing ? 'Üyelik Tipi Düzenle' : 'Yeni Üyelik Tipi'}</h2>
                <button className="adm-modal-close" onClick={() => setModal(null)}><SvgIcon name="x" /></button>
              </div>
              <div className="adm-modal-body">
                <label>Ad<input value={modal.data.name} onChange={e => setModal(prev => ({ ...prev, data: { ...prev.data, name: e.target.value } }))} /></label>
                <label>Slug<input value={modal.data.slug} onChange={e => setModal(prev => ({ ...prev, data: { ...prev.data, slug: e.target.value } }))} placeholder="otomatik oluşur" /></label>
                <div className="adm-modal-row">
                  <label>Aylık Fiyat (₺)<input type="number" value={modal.data.monthlyPrice} onChange={e => setModal(prev => ({ ...prev, data: { ...prev.data, monthlyPrice: Number(e.target.value) } }))} /></label>
                  <label>İndirim (%)<input type="number" min="0" max="100" value={Math.round((modal.data.editorDiscountPct || 0) * 100)} onChange={e => setModal(prev => ({ ...prev, data: { ...prev.data, editorDiscountPct: Number(e.target.value) / 100 } }))} /></label>
                  <label>Koltuk<input type="number" min="1" value={modal.data.maxSeats} onChange={e => setModal(prev => ({ ...prev, data: { ...prev.data, maxSeats: Number(e.target.value) } }))} /></label>
                </div>
                <label>Dahil Editörler</label>
                <div className="adm-pricing-editor-checklist">
                  {pricingEditors.filter(e => e.status === 'published').map(e => (
                    <label key={e.id} className="adm-pricing-check-row">
                      <input type="checkbox" checked={(modal.data.includedEditorIds || []).includes(e.id)} onChange={() => {
                        setModal(prev => {
                          const ids = prev.data.includedEditorIds || [];
                          const next = ids.includes(e.id) ? ids.filter(x => x !== e.id) : [...ids, e.id];
                          return { ...prev, data: { ...prev.data, includedEditorIds: next } };
                        });
                      }} />
                      <span className="adm-pricing-badge" style={{ background: VOLTAGE_COLORS[e.voltageLevel] }}>{e.voltageLevel}</span>
                      <span>{e.name}</span>
                      <span className="adm-muted-text" style={{ marginLeft: 'auto' }}>₺{e.listPrice}/ay</span>
                    </label>
                  ))}
                </div>
                <label>Özellikler (satır satır)</label>
                <textarea rows={4} value={(modal.data.features || []).join('\n')} onChange={e => setModal(prev => ({ ...prev, data: { ...prev.data, features: e.target.value.split('\n').filter(Boolean) } }))} placeholder="Her satır bir özellik" />
              </div>
              <div className="adm-modal-footer">
                <button className="adm-btn" onClick={() => setModal(null)}>İptal</button>
                <button className="adm-btn primary" onClick={handlePricingTierSave}>{modal.editing ? 'Güncelle' : 'Oluştur'}</button>
              </div>
            </div>
          </div>
        )}

        {modal?.type === 'pricing-editor' && (
          <div className="adm-modal-backdrop" onClick={() => setModal(null)}>
            <div className="adm-modal" style={{ maxWidth: 480 }} onClick={e => e.stopPropagation()}>
              <div className="adm-modal-header">
                <h2>{modal.editing ? 'Editör Düzenle' : 'Yeni Editör'}</h2>
                <button className="adm-modal-close" onClick={() => setModal(null)}><SvgIcon name="x" /></button>
              </div>
              <div className="adm-modal-body">
                <label>Ad<input value={modal.data.name} onChange={e => setModal(prev => ({ ...prev, data: { ...prev.data, name: e.target.value } }))} /></label>
                <label>Slug<input value={modal.data.slug} onChange={e => setModal(prev => ({ ...prev, data: { ...prev.data, slug: e.target.value } }))} placeholder="otomatik oluşur" /></label>
                <label>Açıklama<textarea rows={2} value={modal.data.description} onChange={e => setModal(prev => ({ ...prev, data: { ...prev.data, description: e.target.value } }))} /></label>
                <div className="adm-modal-row">
                  <label>Gerilim Seviyesi
                    <select value={modal.data.voltageLevel} onChange={e => setModal(prev => ({ ...prev, data: { ...prev.data, voltageLevel: e.target.value } }))}>
                      <option value="AG">AG</option><option value="OG">OG</option><option value="YG">YG</option><option value="ZA">ZA</option>
                    </select>
                  </label>
                  <label>Liste Fiyatı (₺/ay)<input type="number" value={modal.data.listPrice} onChange={e => setModal(prev => ({ ...prev, data: { ...prev.data, listPrice: Number(e.target.value) } }))} /></label>
                </div>
              </div>
              <div className="adm-modal-footer">
                <button className="adm-btn" onClick={() => setModal(null)}>İptal</button>
                <button className="adm-btn primary" onClick={handlePricingEditorSave}>{modal.editing ? 'Güncelle' : 'Oluştur'}</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  /* ═══════════════════════════════════════════════
     RENDER — Settings
     ═══════════════════════════════════════════════ */
  const renderSettings = () => (
    <div className="adm-settings-grid">
      <div className="adm-setting-card">
        <h3>Genel</h3>
        <label>Site Adı<input value={sysSettings.siteName || ''} onChange={e => setSysSettings(p => ({ ...p, siteName: e.target.value }))} /></label>
        <label>Varsayılan Plan
          <select value={sysSettings.defaultPlanId || 'plan-free'} onChange={e => setSysSettings(p => ({ ...p, defaultPlanId: e.target.value }))}>
            {plans.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </label>
      </div>
      <div className="adm-setting-card">
        <h3>Erişim</h3>
        <label className="adm-toggle-label">
          <span>Kayıt Açık</span>
          <input type="checkbox" checked={sysSettings.registrationOpen !== false} onChange={e => setSysSettings(p => ({ ...p, registrationOpen: e.target.checked }))} />
          <span className="adm-toggle-slider" />
        </label>
        <label className="adm-toggle-label">
          <span>Bakım Modu</span>
          <input type="checkbox" checked={!!sysSettings.maintenanceMode} onChange={e => setSysSettings(p => ({ ...p, maintenanceMode: e.target.checked }))} />
          <span className="adm-toggle-slider" />
        </label>
      </div>
      <div className="adm-setting-card">
        <h3>Dosya & Paylaşım</h3>
        <label>Maks. Dosya Boyutu (MB)<input type="number" value={sysSettings.maxUploadSize || 10} onChange={e => setSysSettings(p => ({ ...p, maxUploadSize: Number(e.target.value) }))} /></label>
        <label>İzin Verilen Dosya Türleri<input value={sysSettings.allowedFileTypes || ''} onChange={e => setSysSettings(p => ({ ...p, allowedFileTypes: e.target.value }))} /></label>
        <label>Paylaşım Linki Süresi (gün)<input type="number" value={sysSettings.shareLinkExpiryDays || 30} onChange={e => setSysSettings(p => ({ ...p, shareLinkExpiryDays: Number(e.target.value) }))} /></label>
      </div>
      <div className="adm-setting-card">
        <h3>DWG Dönüşümü</h3>
        <label className="adm-toggle-label">
          <span>DWG → DXF Dönüşümü Aktif</span>
          <input type="checkbox" checked={sysSettings.dwgToDxfEnabled !== false} onChange={e => setSysSettings(p => ({ ...p, dwgToDxfEnabled: e.target.checked }))} />
          <span className="adm-toggle-slider" />
        </label>
        <div className="adm-setting-warning">
          <strong>⚠ Lisans Uyarısı:</strong> Bu özellik sunucuda <b>ODA File Converter</b> (veya eşdeğer ticari SDK) kurulumu gerektirir.
          ODA File Converter <em>yalnızca ticari olmayan kullanım</em> için ücretsizdir; SaaS/ticari dağıtımda <b>Open Design Alliance'tan lisans</b> alınması zorunludur.
          Devre dışı bırakırsanız istemci (tarayıcı) WASM dönüştürücüsü kullanılır; R14–R2020 arası DWG'ler için çalışır, daha yeni sürümler reddedilir.
        </div>
      </div>
      <div className="adm-settings-save">
        <button className="adm-btn primary" onClick={async () => {
          await apiFetch('/settings', { method: 'PUT', body: JSON.stringify(sysSettings) });
        }}>Ayarları Kaydet</button>
      </div>
    </div>
  );

  /* ═══════════════════════════════════════════════
     DAĞITIM ŞİRKETLERİ
     ═══════════════════════════════════════════════ */

  const renderDistCompanies = () => {
    const TURKEY_CITIES = [
      'Adana','Adıyaman','Afyonkarahisar','Ağrı','Aksaray','Amasya','Ankara','Antalya',
      'Ardahan','Artvin','Aydın','Balıkesir','Bartın','Batman','Bayburt','Bilecik',
      'Bingöl','Bitlis','Bolu','Burdur','Bursa','Çanakkale','Çankırı','Çorum',
      'Denizli','Diyarbakır','Düzce','Edirne','Elazığ','Erzincan','Erzurum','Eskişehir',
      'Gaziantep','Giresun','Gümüşhane','Hakkari','Hatay','Iğdır','Isparta','İstanbul',
      'İzmir','Kahramanmaraş','Karabük','Karaman','Kars','Kastamonu','Kayseri','Kilis',
      'Kırıkkale','Kırklareli','Kırşehir','Kocaeli','Konya','Kütahya','Malatya','Manisa',
      'Mardin','Mersin','Muğla','Muş','Nevşehir','Niğde','Ordu','Osmaniye','Rize',
      'Sakarya','Samsun','Siirt','Sinop','Sivas','Şanlıurfa','Şırnak','Tekirdağ',
      'Tokat','Trabzon','Tunceli','Uşak','Van','Yalova','Yozgat','Zonguldak',
    ];

    const illerFromStr = (s) => s.split(',').map(i => i.trim()).filter(Boolean);

    const handleSave = async () => {
      const payload = {
        name: distForm.name.trim(),
        fullName: distForm.fullName.trim(),
        website: distForm.website.trim(),
        iller: illerFromStr(distForm.iller),
        not: distForm.not.trim(),
      };
      if (!payload.name) { alert('Şirket adı zorunlu.'); return; }
      if (!payload.iller.length) { alert('En az bir il girin.'); return; }

      if (distEditing) {
        const res = await distApiFetch(`/${distEditing}`, { method: 'PUT', body: JSON.stringify(payload) });
        if (res) {
          setDistCompanies(prev => prev.map(c => c.id === distEditing ? res.company : c));
          setDistEditing(null);
          setDistForm({ name: '', fullName: '', website: '', iller: '', not: '' });
        }
      } else {
        const res = await distApiFetch('', { method: 'POST', body: JSON.stringify(payload) });
        if (res) {
          setDistCompanies(prev => [...prev, res.company]);
          setDistForm({ name: '', fullName: '', website: '', iller: '', not: '' });
        }
      }
    };

    const handleEdit = (c) => {
      setDistEditing(c.id);
      setDistForm({
        name: c.name,
        fullName: c.fullName || '',
        website: c.website || '',
        iller: (c.iller || []).join(', '),
        not: c.not || '',
      });
    };

    const handleDelete = async (id) => {
      if (!window.confirm('Bu şirketi silmek istediğinizden emin misiniz?')) return;
      const res = await distApiFetch(`/${id}`, { method: 'DELETE' });
      if (res !== null) setDistCompanies(prev => prev.filter(c => c.id !== id));
    };

    const handleToggleActive = async (c) => {
      const res = await distApiFetch(`/${c.id}`, { method: 'PUT', body: JSON.stringify({ isActive: !c.isActive }) });
      if (res) setDistCompanies(prev => prev.map(x => x.id === c.id ? res.company : x));
    };

    return (
      <div>
        <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 16 }}>
          EPDK'nın 21 elektrik dağıtım bölgesindeki şirketleri yönetin. Şirket listesi, projelerim sayfasında il seçilince otomatik dağıtım firması atamasında kullanılır.
        </p>

        {/* Form */}
        <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8, padding: 16, marginBottom: 24 }}>
          <h3 style={{ marginBottom: 12, fontSize: 14 }}>{distEditing ? 'Şirketi Düzenle' : 'Yeni Şirket Ekle'}</h3>
          <div className="adm-form-row">
            <label className="adm-form-label">Kısa Ad (örn. BEDAŞ)
              <input className="adm-input" value={distForm.name} onChange={e => setDistForm(p => ({ ...p, name: e.target.value }))} placeholder="BEDAŞ" />
            </label>
            <label className="adm-form-label">Tam Ad
              <input className="adm-input" value={distForm.fullName} onChange={e => setDistForm(p => ({ ...p, fullName: e.target.value }))} placeholder="Boğaziçi Elektrik Dağıtım A.Ş." />
            </label>
          </div>
          <div className="adm-form-row">
            <label className="adm-form-label">Website
              <input className="adm-input" value={distForm.website} onChange={e => setDistForm(p => ({ ...p, website: e.target.value }))} placeholder="https://www.bedas.com.tr" />
            </label>
            <label className="adm-form-label">Not (örn. Avrupa Yakası)
              <input className="adm-input" value={distForm.not} onChange={e => setDistForm(p => ({ ...p, not: e.target.value }))} placeholder="İsteğe bağlı açıklama" />
            </label>
          </div>
          <div className="adm-form-row">
            <label className="adm-form-label" style={{ flex: 1 }}>Yetkili İller (virgülle ayırın)
              <input className="adm-input" value={distForm.iller} onChange={e => setDistForm(p => ({ ...p, iller: e.target.value }))} placeholder="İstanbul, Ankara, İzmir" />
            </label>
          </div>
          <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 12 }}>
            Geçerli il adları: {TURKEY_CITIES.join(', ')}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="adm-btn primary" onClick={handleSave}>{distEditing ? 'Güncelle' : 'Ekle'}</button>
            {distEditing && (
              <button className="adm-btn" onClick={() => { setDistEditing(null); setDistForm({ name: '', fullName: '', website: '', iller: '', not: '' }); }}>İptal</button>
            )}
          </div>
        </div>

        {/* List */}
        <div className="adm-table-wrap">
          <table className="adm-table">
            <thead>
              <tr>
                <th>Ad</th>
                <th>Tam Ad</th>
                <th>Yetkili İller</th>
                <th>Not</th>
                <th>Durum</th>
                <th>İşlem</th>
              </tr>
            </thead>
            <tbody>
              {distCompanies.length === 0 && (
                <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--muted)', padding: 24 }}>Henüz şirket yok</td></tr>
              )}
              {distCompanies.map(c => (
                <tr key={c.id}>
                  <td><strong>{c.name}</strong></td>
                  <td style={{ fontSize: 12, color: 'var(--muted)' }}>{c.fullName}</td>
                  <td style={{ fontSize: 12 }}>
                    {(c.iller || []).map(il => (
                      <span key={il} style={{ display: 'inline-block', background: 'var(--primary-10, #e0f2fe)', color: 'var(--primary, #0369a1)', borderRadius: 4, padding: '1px 6px', margin: '1px 2px', fontSize: 11 }}>{il}</span>
                    ))}
                  </td>
                  <td style={{ fontSize: 12, color: 'var(--muted)' }}>{c.not || '—'}</td>
                  <td>
                    <label className="adm-toggle-label" style={{ margin: 0 }}>
                      <input type="checkbox" checked={c.isActive !== false} onChange={() => handleToggleActive(c)} />
                      <span className="adm-toggle-slider" />
                    </label>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 4 }}>
                      <button className="adm-btn" style={{ padding: '3px 8px', fontSize: 12 }} onClick={() => handleEdit(c)}>Düzenle</button>
                      <button className="adm-btn danger" style={{ padding: '3px 8px', fontSize: 12 }} onClick={() => handleDelete(c.id)}>Sil</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p style={{ fontSize: 12, color: 'var(--muted)', marginTop: 8 }}>
          Toplam {distCompanies.length} şirket · Aktif: {distCompanies.filter(c => c.isActive !== false).length}
        </p>
      </div>
    );
  };

  /* ═══════════════════════════════════════════════
     MAIN RENDER
     ═══════════════════════════════════════════════ */
  const sectionTitle = sectionList.find(s => s.id === section)?.label || '';

  return (
    <div className="admin-page">
      <header className="adm-header">
        <div className="adm-header-left">
          <div className="adm-brand" onClick={() => navigate('/dashboard')}>
            <img src="/favicon.svg" alt="P" className="adm-brand-icon" />
            <span className="adm-brand-text">Pro<span>jabze</span> Admin</span>
          </div>
        </div>
        <div className="adm-header-right">
          <button className="adm-btn" onClick={() => navigate('/dashboard')}><SvgIcon name="back" size={16} /> Siteye Dön</button>
          <div className="adm-header-user">
            <div className="adm-header-avatar">{(user.firstName?.[0] || '') + (user.lastName?.[0] || '')}</div>
            <span>{user.firstName}</span>
          </div>
        </div>
      </header>

      <div className="adm-body">
        <aside className="adm-sidebar">
          {sectionList.map(s => (
            <button key={s.id} className={`adm-sidebar-item ${section === s.id ? 'active' : ''}`} onClick={() => setSection(s.id)}>
              <span className="adm-sidebar-icon"><SvgIcon name={s.icon} /></span>
              <span className="adm-sidebar-label">{s.label}</span>
            </button>
          ))}
        </aside>

        <main className="adm-main">
          <div className="adm-main-header"><h1>{sectionTitle}</h1></div>
          <div className="adm-content">
            {loading ? (
              <div className="adm-loading">Yükleniyor...</div>
            ) : (
              <>
                {section === 'dashboard' && renderDashboard()}
                {section === 'users' && renderUsers()}
                {section === 'plans' && renderPlans()}
                {section === 'disciplines' && renderDisciplines()}
                {section === 'projects' && renderProjects()}
                {section === 'system-roles' && renderSystemRoles()}
                {section === 'forum' && renderForum()}
                {section === 'posts' && renderPosts()}
                {section === 'jobs' && renderJobs()}
                {section === 'contacts' && renderContacts()}
                {section === 'testimonials' && renderTestimonials()}
                {section === 'legal' && renderLegal()}
                {section === 'pricing' && renderPricing()}
                {section === 'navigation' && renderNavigation()}
                {section === 'distribution-companies' && renderDistCompanies()}
                {section === 'settings' && renderSettings()}
              </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Admin;
